{
  "\"chart.tooltip.substat.phase\"": "Phase {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}",
  "\"chart.tooltip.substat.pv_string\"": "{inverterName}, String {stringNumber}",
  "TEST": "XXX",
  "animation.battery": "Battery",
  "animation.boiler": "Boiler",
  "animation.consumption": "House",
  "animation.electrical_grid": "Grid",
  "animation.hp": "Heat pump",
  "animation.photovoltaics": "Photovoltaics",
  "animation.wallbox": "Wallbox",
  "animation.wind": "Wind",
  "app_messages.battery_max_soc": "Charging battery to set maximum SOC {maxSoc, number, ::.##}%",
  "app_messages.battery_min_soc": "Discharging battery to set minimum SOC {minSoc, number, ::.##}%",
  "app_messages.body.battery_max_soc": "The current battery charge level is {currentSoc, number, ::.##}%.",
  "app_messages.body.battery_min_soc": "The current battery charge level is {currentSoc, number, ::.##}%.",
  "app_messages.body.heat_pump_limit_exceeded": "The heat pump consumption limit has been exceeded. The set limit is {value, number, ::.##} kW.",
  "app_messages.body.heat_water_limit_exceeded": "The heat water consumption limit has been exceeded. The set limit is {value, number, ::.##} kW.",
  "app_messages.body.heat_water_max_temperature": "Today the boiler has already reached the maximum temperature {maxTemperature, number, ::.##}°C.",
  "app_messages.body.home_limit_exceeded": "The home consumption limit has been exceeded. The set limit is {value, number, ::.##} kW.",
  "app_messages.body.inverter_production_mwh": "Your photovoltaic plant has already produced {inverterProductionValue, number, ::.##} MWh this year.",
  "app_messages.body.spot_daily_prediction": "Daily prediction: {pvPrediction, select, true {Photovoltaics production: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {Home consumption: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Battery storage: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Boiler storage: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {Heat pump consumption: {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Remaining energy for sale: {salePredictionValue, number, ::.##} kWh. } other {} }",
  "app_messages.body.spot_daily_summary": "Today on the spot: {nothingToReport, select, true {Nothing is planned.} other { {energyForSale, select, true {The plan is to sell in the morning. } other {} } {negativeIntervals, select, false {} other {Negative price ({negativeIntervals}), which will reduce overflow. } } {chargingIntervals, select, false {} other {Battery charging plan ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Battery discharging plan ({dischargingIntervals}). } } } }",
  "app_messages.body.spot_negative_price_start": "The current spot price is negative after deducting the commission. The commission set in Infigy is {spotOffsetPrice, number, ::.##} CZK. The current spot price is {spotNegativePrice, number, ::.##} CZK.",
  "app_messages.body.spot_negative_price_stop": "The current spot price is no longer negative and is {spotNegativePrice, number, ::.##} CZK. The commission is set in Infigy at {spotOffsetPrice, number, ::.##} CZK",
  "app_messages.body.wallbox_limit_exceeded": "The charging limit of the electric vehicle has been exceeded. The set limit is {value, number, ::.##} kW.",
  "app_messages.body.wallbox_stop_charging": "In this cycle, {wallboxConsumptionCycleValue, number, ::.##} kWh of energy was added.",
  "app_messages.button": "Delete all messages",
  "app_messages.cancel": "Cancel",
  "app_messages.confirm": "Delete all messages",
  "app_messages.confirm.title": "Do you really want to delete all messages?",
  "app_messages.detail_dialog.close": "Read",
  "app_messages.heat_pump_limit_exceeded": "The heat pump consumption limit has been exceeded",
  "app_messages.heat_water_limit_exceeded": "The heat water consumption limit has been exceeded",
  "app_messages.heat_water_max_temperature": "The maximum temperature of the water has been reached",
  "app_messages.home_limit_exceeded": "The home consumption limit has been exceeded",
  "app_messages.inverter_connected": "Communication with the inverter has been established",
  "app_messages.inverter_disconnected": "Communication with the inverter has been lost",
  "app_messages.inverter_production_mwh": "PV production milestone",
  "app_messages.load_more": "Load more",
  "app_messages.no_messages": "There are no notifications here yet",
  "app_messages.spot_battery_discharge": "Spot-based discharge plan is {spotDischargePlan}",
  "app_messages.spot_daily_prediction": "Daily prediction",
  "app_messages.spot_daily_summary": "Daily summary of the spot plan",
  "app_messages.spot_negative_price_start": "The spot price is negative",
  "app_messages.spot_negative_price_stop": "The spot price is no longer negative",
  "app_messages.spot_start_charging_battery": "Battery charging according to the spot price has started",
  "app_messages.spot_start_discharging_battery": "Battery discharging to the grid according to the spot price has started",
  "app_messages.spot_stop_charging_battery": "Battery charging according to the spot price has been stopped",
  "app_messages.spot_stop_discharging_battery": "Battery discharging to the grid according to the spot price has been stopped",
  "app_messages.test": "Test notification",
  "app_messages.title": "Delete all messages",
  "app_messages.utility_loss_start": "We have detected a power outage",
  "app_messages.utility_loss_stop": "The power outage has been resolved",
  "app_messages.wallbox_limit_exceeded": "The charging limit of the electric vehicle has been exceeded",
  "app_messages.wallbox_start_charging": "The electric vehicle charging has started",
  "app_messages.wallbox_stop_charging": "The electric vehicle charging has been stopped",
  "app_update_overlay.subtitle": "Please wait. After the update, the application will restart and the window in the browser will automatically refresh",
  "app_update_overlay.title": "Update in progress",
  "audit_log.error": "Error while loading",
  "audit_log.item.author": "Author",
  "audit_log.item.date": "Date",
  "audit_log.item.payload": "Event",
  "audit_log.item.type": "Type",
  "audit_log.title": "Audit Log",
  "audit_log_delete.button": "Delete",
  "audit_log_delete.cancel": "Cancel",
  "audit_log_delete.confirm": "Delete",
  "audit_log_delete.confirm.title": "Do you really want to delete all records in the audit log?",
  "audit_log_delete.title": "Delete audit log",
  "azRouters.add": "Add new AZ router",
  "azRouters.addButton": "Add",
  "azRouters.clientId": "Modbus ID",
  "azRouters.clientId.value": "Modbus ID: {id}",
  "azRouters.counts": "OK {ok} / Error {err}",
  "azRouters.empty": "No AZ routers configured",
  "azRouters.name": "Name",
  "azRouters.status.error": "Error",
  "azRouters.status.ok": "OK",
  "azRouters.status.starting": "Starting",
  "azRouters.title": "AZ routers",
  "bez_dodavatele.business_flexibility.title": "Business flexibility",
  "bez_dodavatele.enabled": "Integration enabled",
  "bez_dodavatele.region": "Region code",
  "bez_dodavatele.title": "bezDodavatele",
  "boiler.blocking": "Heating blockage",
  "boiler.common": "General information",
  "boiler.common.phase_3": "Phase 3:",
  "boiler.common.power": "Total consumption",
  "boiler.common.power.phase_1": "Phase 1:",
  "boiler.common.power.phase_2": "Phase 2:",
  "boiler.common.power_today": "Today's consumption:",
  "boiler.common.power_year": "Annual consumption:",
  "boiler.common.temperature": "Current temperature",
  "boiler.common.total": "Total consumption",
  "boiler.settings": "Settings",
  "boiler.settings.hdo": "Turn off the regular heating in the high tariff",
  "boiler.settings.hdo.subtitle": "Times for the high tariff must be set in the general settings",
  "boiler.settings.min_soc": "Heating block",
  "boiler.settings.min_soc.subtitle": "Battery charge level at which heating is blocked during a power outage",
  "boiler.settings.min_soc_utility": "Heating block when the grid is available",
  "boiler.settings.min_soc_utility.subtitle": "Battery charge level at which heating is blocked during a power outage",
  "boiler.settings.spot-hi": "Block heating at high spot price",
  "boiler.settings.spot-mi": "Block heating at medium spot price",
  "boiler.settings.temp": "Set temperature",
  "boiler.settings.temp.subtitle": "A common temperature that is always available",
  "boiler.settings.temp_ek": "Temperature from photovoltaics using electric boiler",
  "boiler.settings.temp_ek.subtitle": "Preheating temperature that is only for a low price",
  "boiler.settings.temp_spot": "Temperature from the spot using electric boiler",
  "boiler.settings.temp_spot.subtitle": "Preheating temperature that is only for a low price",
  "boiler.statistics": "Statistics",
  "boiler.statisticsTemp": "Boiler temperature",
  "boiler.status": "Boiler mode",
  "boiler.status.home": "Boiler mode",
  "boiler_test_trigger.button": "Test boiler",
  "boiler_test_trigger.button.running": "Test is running",
  "boiler_test_trigger.subtitle": "Verifies the correct connection and the set power of the boiler.",
  "boiler_test_trigger.title": "Test boiler",
  "boiler_test_wizard.acknowledge.condition": "For a correct boiler test, the consumption in the object must be constant or zero. Any fluctuations in consumption can affect the test. The current consumption of the object is {power}",
  "boiler_test_wizard.acknowledge.config": "Currently, the {phaseLabel} boiler is set with a total power of {power}. These values must be set according to the label of the boiler.",
  "boiler_test_wizard.acknowledge.confirm": "Confirm",
  "boiler_test_wizard.acknowledge.phase1": "1-phase",
  "boiler_test_wizard.acknowledge.phase3": "3-phase",
  "boiler_test_wizard.acknowledge.phase_option": "{phase}. phase",
  "boiler_test_wizard.acknowledge.phase_select": "Select phases to test. Unmarked phases will be skipped.",
  "boiler_test_wizard.acknowledge.phase_select_empty": "Select at least one phase.",
  "boiler_test_wizard.acknowledge.start": "Test boiler",
  "boiler_test_wizard.acknowledge.title": "Information for the test",
  "boiler_test_wizard.result.after": "Consumption of the object after activation",
  "boiler_test_wizard.result.before": "Consumption of the object before activation",
  "boiler_test_wizard.result.close": "Close",
  "boiler_test_wizard.result.correct": "Correct boiler consumption",
  "boiler_test_wizard.result.detail_toggle": "Test detail",
  "boiler_test_wizard.result.header": "Test result:",
  "boiler_test_wizard.result.phase_header": "{phase}. phase",
  "boiler_test_wizard.result.real_power": "Estimated boiler power",
  "boiler_test_wizard.result.rerun": "Run test again",
  "boiler_test_wizard.result.set_power": "Set power",
  "boiler_test_wizard.result.stable": "Measurement was stable",
  "boiler_test_wizard.result.title": "Test result",
  "boiler_test_wizard.running.activate": "Activation of the boiler phase",
  "boiler_test_wizard.running.after": "Consumption of the object is {power}",
  "boiler_test_wizard.running.before": "Consumption of the object before the test is {power}",
  "boiler_test_wizard.running.measuring": "Measurement is in progress…",
  "boiler_test_wizard.running.phase": "Testing phase {phase}",
  "boiler_test_wizard.running.real_power": "Estimated boiler power is {power}",
  "boiler_test_wizard.running.remaining": "Remaining approximately {seconds} s",
  "boiler_test_wizard.running.reset": "Resetting consumption",
  "boiler_test_wizard.running.result_fail": "Test phase is not correct",
  "boiler_test_wizard.running.result_ok": "Test phase is correct",
  "boiler_test_wizard.running.stable": "Consumption is stable",
  "boiler_test_wizard.running.title": "Test is in progress",
  "boiler_test_wizard.running.unstable": "Measurement was unstable",
  "boiler_test_wizard.title": "Testing boiler",
  "cancel": "Cancel",
  "chart.range.this_week": "Last week",
  "chart.range.today": "Last 24{nbsp}hours",
  "chart.tooltip.active_condition.title": "Current mode:",
  "chart.tooltip.active_condition.value.battery": "Battery",
  "chart.tooltip.active_condition.value.compressor-blocked": "Compressor blocked, low battery level",
  "chart.tooltip.active_condition.value.cooling": "Cooling",
  "chart.tooltip.active_condition.value.error": "Error",
  "chart.tooltip.active_condition.value.heating": "Heating",
  "chart.tooltip.active_condition.value.hot-water": "Hot water heating",
  "chart.tooltip.active_condition.value.inactive": "Inactive",
  "chart.tooltip.active_condition.value.manual": "Manual",
  "chart.tooltip.active_condition.value.not-connected": "Cannot establish connection",
  "chart.tooltip.active_condition.value.not-licensed": "Not licensed",
  "chart.tooltip.active_condition.value.off": "Off",
  "chart.tooltip.active_condition.value.overflow": "Overflow",
  "chart.tooltip.active_condition.value.pool": "Pool heating",
  "chart.tooltip.active_condition.value.spot": "Spot",
  "chart.tooltip.active_condition.value.time": "Time",
  "chart.tooltip.control_mode.title": "Controlled by:",
  "chart.tooltip.control_mode.value": "{mode, select, photovoltaic {Photovoltaics} grid {Grid} spot {Spot} flexibility {Flexibility} error {Error} other {{mode}} }",
  "chart.tooltip.wallbox_authorization_card_id.title": "Authorization card:",
  "charts.error.dialog.title": "An error occurred while loading the statistics",
  "charts.mode.day": "Day",
  "charts.mode.week": "Week",
  "charts.mode.year": "Year",
  "charts.summary.value": "Total {value}",
  "close": "Close",
  "cloud_plugs.bat": "Control by battery",
  "cloud_plugs.battery.battery_start": "Turn on when charging",
  "cloud_plugs.battery.battery_start.subtitle": "Battery charging which activates the outlet",
  "cloud_plugs.battery.battery_stop": "Turn off when charging",
  "cloud_plugs.battery.battery_stop.subtitle": "Charging the battery, which turns off the socket",
  "cloud_plugs.battery.on": "Active",
  "cloud_plugs.battery_charged": "Battery charged",
  "cloud_plugs.condition": "Condition",
  "cloud_plugs.condition.and": "And",
  "cloud_plugs.condition.or": "Or",
  "cloud_plugs.led_mode.battery.subtitle": "LED active if the battery is at least 95%",
  "cloud_plugs.led_mode.battery.switch.title": "LED when the socket is switched on",
  "cloud_plugs.led_mode.battery.title": "LED when the battery is charged",
  "cloud_plugs.led_mode.mode": "{mode, select, unknown {---} off {Off} switch {} power {By power} other {Unknown}}",
  "cloud_plugs.led_mode.overflow.subtitle": "LED active if stable overflow occurs",
  "cloud_plugs.led_mode.overflow.title": "LED when overflow occurs",
  "cloud_plugs.led_mode.switch.subtitle": "LED active if the socket is switched on",
  "cloud_plugs.led_mode.title": "LED signaling",
  "cloud_plugs.list.id": "ID",
  "cloud_plugs.list.led_mode": "LED signaling",
  "cloud_plugs.list.online": "Online",
  "cloud_plugs.list.relay": "Relay",
  "cloud_plugs.list.title": "Status",
  "cloud_plugs.overflow": "Control by overflow",
  "cloud_plugs.overflow.help": "Turning on the socket at a defined overflow to the grid.",
  "cloud_plugs.overflow.on": "Active",
  "cloud_plugs.overflow.startPower": "Turn on when consuming from the grid",
  "cloud_plugs.overflow.startPower.help": "The socket turns on if the overflow is at the set level after a defined delay. If the value is set to - 1500W and the turn-on delay is 5 minutes, the socket turns on when the overflow into the network is at least 1500W for 5 minutes.",
  "cloud_plugs.overflow.startPower.subtitle": "Negative value is overflow, positive value is consumption",
  "cloud_plugs.overflow.stopPower": "Turn off when consuming from the grid",
  "cloud_plugs.overflow.stopPower.help": "The socket turns off if the consumption is higher than the set level after a defined delay. If the value is set to 100W and the turn-off delay is 5 minutes, the socket turns off when the consumption from the network is at least 100W for 5 minutes.",
  "cloud_plugs.overflow.stopPower.subtitle": "Negative value is overflow, positive value is consumption",
  "cloud_plugs.pv_power": "Control by PV power",
  "cloud_plugs.pv_power.help": "Turning on the socket at a defined PV power.",
  "cloud_plugs.pv_power.on": "Active",
  "cloud_plugs.pv_power.startPower": "Turn on when producing PV",
  "cloud_plugs.pv_power.startPower.help": "The socket turns on if the PV power is greater than the set level. If the value is set to 1000W, the socket turns on when the PV power is at least 1000W.",
  "cloud_plugs.pv_power.stopPower": "Turn off when producing PV",
  "cloud_plugs.pv_power.stopPower.help": "The socket turns off if the PV power is less than the set level. If the value is set to 500W, the socket turns off when the PV power is less than 500W.",
  "cloud_plugs.time": "Control by time",
  "cloud_plugs.time.on": "Active",
  "cloud_plugs.title": "Sockets",
  "cloud_plugs.turn_off": "Turn off",
  "cloud_plugs.turn_on": "Turn on",
  "dark_mode.dark": "Dark",
  "dark_mode.light": "Light",
  "dark_mode.system": "System",
  "delta_green.battery_max_power_in": "Maximum battery power IN (W)",
  "delta_green.battery_max_power_out": "Maximum battery power OUT (W)",
  "delta_green.business_flexibility.title": "Business flexibility",
  "delta_green.connected": "Status",
  "delta_green.enabled": "Integration enabled",
  "delta_green.last_messages": "Last messages",
  "delta_green.last_messages.date": "Time",
  "delta_green.last_messages.payload": "Message",
  "delta_green.last_messages.topic": "Topic",
  "delta_green.pv_orientation": "Photovoltaic orientation",
  "delta_green.title": "Delta Green",
  "des_battery_container.status.error": "Error",
  "des_battery_container.status.none": "Unknown status",
  "des_battery_container.status.off": "Off",
  "des_battery_container.status.run": "Normal mode",
  "des_battery_container.status.sleep": "Sleep mode",
  "dev.cloud_plugs.mqtt_cloud.connected": "MQTT Cloud connection status",
  "dev.cloud_plugs.title": "Cloud sockets",
  "dev.inverter_config.connection.lan": "LAN",
  "dev.inverter_config.connection.rs485": "RS485",
  "dev.inverter_config.connection.rs485_hint": "Address and port are taken from the board ({host}:{port}).",
  "dev.inverter_config.rename_warning": "Renaming the key from \"{from}\" to \"{to}\" will orphan historical data — statistics and produced energy stored under the original key.",
  "dev.inverter_config.search.open": "Search for inverter",
  "dev.inverter_config.search.title": "Search for inverter",
  "dev.inverter_config.stats.all": "All",
  "dev.inverter_config.status.counts": "OK {ok} / Errors {err}",
  "dev.inverter_config.status.error": "Error",
  "dev.inverter_config.status.ok": "OK",
  "dev.inverter_config.status.starting": "Starting",
  "dev.inverter_config.title": "Inverter configuration",
  "dev.link": "Dev",
  "dev_app_messages.test_send": "Test notification",
  "dev_app_messages.test_send.button": "Send",
  "dev_homepage.app_messages.title": "Notifications",
  "dev_homepage.title": "Development menu",
  "dev_spot.summary.title": "Mode overview",
  "dev_spot.title": "Spot (Development)",
  "dev_status_log.empty": "No data yet",
  "dev_status_log.error": "Error while loading",
  "dev_status_log.title": "Status log",
  "dev_status_log.today": "Today",
  "dhcp_host.address": "IP address",
  "dhcp_host.create.title": "New DHCP host",
  "dhcp_host.edit.title": "Edit DHCP host",
  "dhcp_host.mac": "MAC address",
  "dhcp_host.name": "Name",
  "dhcp_hosts.remove.cancel": "Cancel",
  "dhcp_hosts.remove.confirm": "Delete",
  "dhcp_hosts.remove.confirm.title": "Do you really want to unfix the DHCP host address?",
  "dhcp_leases.ip": "IP address",
  "dhcp_leases.mac": "MAC address",
  "dhcp_leases.make_static.cancel": "Cancel",
  "dhcp_leases.make_static.confirm": "Add",
  "dhcp_leases.make_static.confirm.title": "Do you really want to fix the DHCP host address?",
  "dhcp_leases.name": "Name",
  "dhcp_leases.next_renewal": "Next renewal",
  "dhcp_leases.title": "DHCP Leases",
  "ean": "EAN",
  "electree.business_flexibility.title": "Business flexibility",
  "electree.connected": "Status",
  "electree.enabled": "Integration enabled",
  "electree.last_messages": "Last messages",
  "electree.last_messages.date": "Time",
  "electree.last_messages.payload": "Message",
  "electree.last_messages.topic": "Topic",
  "electree.title": "Electree",
  "electrical_grid.common": "General information",
  "electrical_grid.common.overflow": "Total flow to the grid",
  "electrical_grid.common.overflow_today": "Today's overflow to the grid:",
  "electrical_grid.common.overflow_year": "Annual overflow to the grid:",
  "electrical_grid.common.power": "Total consumption from the grid",
  "electrical_grid.common.power.phase_1": "Phase 1:",
  "electrical_grid.common.power.phase_2": "Phase 2:",
  "electrical_grid.common.power.phase_3": "Phase 3:",
  "electrical_grid.common.power_today": "Today's consumption from the grid:",
  "electrical_grid.common.power_year": "Annual consumption from the grid:",
  "electrical_grid.common.total_consumption": "Total consumption from the grid",
  "electrical_grid.statistics": "Purchase statistics",
  "electrical_grid.statistics_overflow": "Overflow statistics",
  "electrical_grid.status": "Status of the grid",
  "ems.activePower": "Active power",
  "ems.apparentPower": "Apparent power",
  "ems.details": "Inverter parameters",
  "ems.inverter": "Inverter",
  "ems.inverter.index": "Inverter {index}",
  "ems.inverter.mode.backup": "Backup",
  "ems.inverter.mode.feedIn": "Feed-in",
  "ems.inverter.mode.manual": "Manual",
  "ems.inverter.mode.peakShaving": "Peak Shaving",
  "ems.inverter.mode.selfUse": "Self use",
  "ems.inverter.name": "Inverter name",
  "ems.inverter.name.aelio": "X3-AELIO",
  "ems.inverter.name.notConnected": "Not connected",
  "ems.inverter.name.trene100k": "X3-TRENE-100K",
  "ems.inverter.name.trene100ki": "X3-TRENE-100KI",
  "ems.inverter.name.trene125k": "X3-TRENE-125K",
  "ems.inverter.name.unknown": "Unknown model",
  "ems.mode": "EMS mode",
  "ems.power.index": "Power {index}",
  "ems.power.total": "Total power",
  "ems.powerFactor": "Power factor",
  "ems.reactivePower": "Reactive power",
  "ems.status": "Status",
  "emsPro.inverter.name.aelio": "X3-AELIO",
  "emsPro.inverter.name.notConnected": "Not connected",
  "emsPro.inverter.name.trene1": "X3-TRENE-1",
  "emsPro.inverter.name.trene100k": "X3-TRENE-100K",
  "emsPro.inverter.name.trene125k": "X3-TRENE-125K",
  "emsPro.inverter.name.x3forth": "X3-FORTH",
  "emsPro.inverter.name.x3forthplus": "X3-FORTH+",
  "emsPro.inverter.name.x3grand": "X3-GRAND",
  "emsPro.inverter.name.x3mgag2": "X3-MGA G2",
  "emsPro.inverter.name.x3prog2": "X3-PRO G2",
  "emsService.basicSettings": "Basic Settings",
  "emsService.direction.disabled": "Disabled",
  "emsService.direction.read": "Read",
  "emsService.direction.write": "Write",
  "emsService.distributionMetrics": "Distribution Commands",
  "emsService.distributionMetrics.diMapping": "Input mapping",
  "emsService.distributionMetrics.enabled": "Enable reading distribution commands",
  "emsService.distributionMetrics.source": "Distribution commands source",
  "emsService.distributionMetrics.source.digitalInputs": "Digital Inputs",
  "emsService.distributionMetrics.source.plc": "External PLC",
  "emsService.enabled": "PLC Enabled",
  "emsService.energyMeters": "Energy Meters",
  "emsService.energyMeters.add": "Add new energy meter",
  "emsService.energyMeters.addButton": "Add",
  "emsService.energyMeters.azRouter": "AZ router",
  "emsService.energyMeters.azRouter.empty": "No AZ routers configured",
  "emsService.energyMeters.empty": "No energy meters configured",
  "emsService.energyMeters.newMeter": "Name",
  "emsService.energyMeters.plcMetric": "PLC Metric",
  "emsService.energyMeters.plcMetric.grid": "Grid",
  "emsService.energyMeters.plcMetric.kgj": "KGJ",
  "emsService.energyMeters.plcMetric.pv": "PV",
  "emsService.energyMeters.shellyId": "Shelly ID",
  "emsService.energyMeters.source": "Source",
  "emsService.energyMeters.source.azRouter": "AZ router",
  "emsService.energyMeters.source.plc": "PLC",
  "emsService.energyMeters.source.shelly": "Shelly",
  "emsService.gridMetrics.enabled": "Grid metrics reading enabled",
  "emsService.ipAddress": "IP Address",
  "emsService.kgjMetrics": "KGJ Metrics",
  "emsService.kgjMetrics.enabled": "KGJ metrics reading enabled",
  "emsService.metricsDirection": "Direction",
  "emsService.metricsEnabled": "Enabled",
  "emsService.mqttBroker": "MQTT Broker (Shellies)",
  "emsService.mqttBrokerEnabled": "MQTT Broker Enabled",
  "emsService.mqttBrokerStatus": "MQTT Broker Status",
  "emsService.notAvailable": "EMS feature is not available",
  "emsService.password": "Password",
  "emsService.plcStatus": "PLC Communication Status",
  "emsService.pollInterval": "Poll Interval (ms)",
  "emsService.pvMetrics": "PV Metrics",
  "emsService.pvMetrics.enabled": "PV metrics reading enabled",
  "emsService.pvMetrics.meterId": "Energy meter",
  "emsService.pvMetrics.meterSource": "Data source",
  "emsService.pvMetrics.meterSource.meter": "Energy meter",
  "emsService.pvMetrics.meterSource.plc": "PLC",
  "emsService.shelliesList": "Connected Shelly Devices",
  "emsService.username": "Username",
  "ems_service.link": "EMS Service",
  "ems_service.title": "EMS Service",
  "enerco.ean": "EAN",
  "enerco.enabled": "Integration enabled",
  "enerco.prediction.disabled": "Integration is disabled.",
  "enerco.prediction.title": "Prediction",
  "enerco.title": "Enerco",
  "energomachine.business_flexibility.title": "Business flexibility",
  "energomachine.connected": "Status",
  "energomachine.enabled": "Integration enabled",
  "energomachine.last_messages": "Last messages",
  "energomachine.last_messages.date": "Time",
  "energomachine.last_messages.payload": "Message",
  "energomachine.last_messages.topic": "Topic",
  "energomachine.title": "Energomachine",
  "energyMeters.actualPower": "Actual power",
  "energyMeters.general": "General Information",
  "energyMeters.meter": "Energy Meter",
  "energyMeters.notConfigured": "Energy meters are not configured. Go to service menu to set them up.",
  "energyMeters.phase1": "Phase 1:",
  "energyMeters.phase2": "Phase 2:",
  "energyMeters.phase3": "Phase 3:",
  "energyMeters.statistics": "Statistics",
  "energyMeters.todayEnergy": "Today's consumption:",
  "energyMeters.totalEnergy": "Total Consumption",
  "energyMeters.yearEnergy": "Yearly consumption:",
  "error": "Error loading report.",
  "expertService.EM": "Energy Meters",
  "expertService.EM.add": "Add",
  "expertService.EM.empty": "No energy meters configured",
  "expertService.EM.list": "Energy Meters Configuration",
  "expertService.EM.name": "Name",
  "expertService.EM.newMeter": "New meter",
  "expertService.EM.shellyId": "Shelly ID",
  "expertService.HP": "Heat pump",
  "expertService.HP.CntComErr": "Error message counter",
  "expertService.HP.CntComOk": "Valid message counter",
  "expertService.HP.IpAdr": "Heat pump IP address",
  "expertService.HP.maxTempHW": "Maximum temperature of hot water for the heat pump",
  "expertService.HP.maxTempHW.subtitle": "Sum of flexible + set temperature",
  "expertService.HW": "Hot water",
  "expertService.HW.HwBatteryPriority": "Battery charge percentage at which the boiler always has priority",
  "expertService.HW.HwErrEnabled": "Evaluate boiler availability",
  "expertService.HW.HwResetErrorTime": "Delay for reset of thermostat error",
  "expertService.HW.HwResetErrorTime.subtitle": "Time in minutes after which the thermostat error is reset and heating starts again",
  "expertService.HW.LegionellaLastTime": "Last time legionella temperature was reached",
  "expertService.HW.TempId": "Temperature sensor ID",
  "expertService.HW.control": "Boiler control type",
  "expertService.HW.control.onoff": "On/Off",
  "expertService.HW.control.proportional": "Proportional",
  "expertService.HW.hysterezis": "Hot water hysteresis",
  "expertService.HW.hysterezis.subtitle": "Hysteresis is only for regular heating",
  "expertService.HW.maxPower": "Maximum power of the boiler in percent",
  "expertService.HW.maxPower.subtitle": "This setting is only for smooth control of the boiler and limits the maximum power of the burner in percent.",
  "expertService.HW.offset": "Phase offset [W]",
  "expertService.HW.offset.disabled-overflow": "Offset for controlling the boiler with disabled overflow on the phase [W]",
  "expertService.HW.offset.disabled-overflow.subtitle": "Higher number allows the boiler to draw more energy from the grid when the overflow is disabled",
  "expertService.HW.offset.enabled-overflow": "Offset for controlling the boiler with enabled overflow on the phase [W]",
  "expertService.HW.offset.enabled-overflow.subtitle": "Higher number allows the boiler to draw more energy from the grid.",
  "expertService.HW.offset.ongrid": "Offset for controlling the boiler with grid power [W]",
  "expertService.HW.offset.ongrid.subtitle": "Higher number allows the boiler to draw more energy from the grid.",
  "expertService.PV": "Photovoltaics",
  "expertService.PV.BatteryPowerPercent": "Battery charging power in percent",
  "expertService.PV.CntComErr": "Error message counter",
  "expertService.PV.CntComOk": "Valid message counter",
  "expertService.PV.ControlMeteringMode": "Surplus control method",
  "expertService.PV.ControlMeteringMode.perPhase": "Per phase",
  "expertService.PV.ControlMeteringMode.subtitle": "Per-phase control calculates the surplus for appliance control from individual phases. Summed control works with the sum of all phases.",
  "expertService.PV.ControlMeteringMode.sum": "Summed",
  "expertService.PV.ExternalPv": "External PV connected via SOLAX Meter 2",
  "expertService.PV.ExternalPvSofar": "External PV connected via SOFAR Meter 2",
  "expertService.PV.IpAdr": "Inverter IP address",
  "expertService.PV.MeteringMode": "Grid metering method",
  "expertService.PV.MeteringMode.perPhase": "Per phase",
  "expertService.PV.MeteringMode.subtitle": "Per-phase metering (CZ) counts import and export on each phase separately. Summed metering works with the net balance of all phases.",
  "expertService.PV.MeteringMode.sum": "Summed",
  "expertService.PV.PowerControlType": "Power control type of the grid inverter",
  "expertService.PV.PowerControlType.fixed": "Fixed",
  "expertService.PV.PowerControlType.proportional": "Proportional",
  "expertService.PV.StringNumber": "Number of strings of the inverter",
  "expertService.PV.StringNumber.subtitle": "Number of strings of the inverter displayed in the application on the PV tab",
  "expertService.PV.Versions": "Version",
  "expertService.SP": "Spot",
  "expertService.SP.HwCoefficient": "Boiler energy estimate coefficient",
  "expertService.SP.HwCoefficient.subtitle": "Coefficient of estimated energy for charging the boiler.",
  "expertService.SP.MinDifferencePriceChargeFromGrid": "Minimum spot price difference for grid battery charging",
  "expertService.SP.batteryCoefficient": "Battery charging time estimate coefficient",
  "expertService.SP.batteryCoefficient.subtitle": "Coefficient of estimated time for charging the battery",
  "expertService.SP.minDifferenceBatterychargeFromGrid": "Minimum estimated SOC increase for waiting for PV",
  "expertService.SP.minDifferenceBatterychargeFromGrid.subtitle": "If the estimated battery charge is below this value, the battery may be charged from the grid.",
  "expertService.WB": "Wallbox",
  "expertService.WB.CntComErr": "Error message counter",
  "expertService.WB.CntComOk": "Valid message counter",
  "expertService.WB.IpAdr": "Wallbox IP address",
  "expertService.general": "General settings",
  "expertService.general.largeInstallation": "Large installation",
  "expertService.general.largeInstallation.subtitle": "Extends the range of values for large installations",
  "expertService.password": "Service access",
  "expertService.password.label": "Password",
  "expert_service.app_messages": "Messages",
  "expert_service.audit_log": "Audit Log",
  "expert_service.error_list": "Error list",
  "expert_service.link": "Expert Service",
  "expert_service.network": "Network",
  "expert_service.network.button": "Go to network settings",
  "expert_service.network.link": "Network",
  "expert_service.reports": "Reports",
  "expert_service.stats": "Statistics",
  "expert_service.title": "Service",
  "expert_service.xyz": "Service",
  "header.title": "Home page",
  "header.title.app_messages": "Messages",
  "header.title.audit_log": "Audit Log",
  "header.title.boiler": "Boiler",
  "header.title.cloud_plugs": "Sockets",
  "header.title.dev": "Network Settings",
  "header.title.dev.app_messages": "Notifications",
  "header.title.dev.az_routers": "AZ routers",
  "header.title.dev.bez_dodavatele": "bezDodavatele",
  "header.title.dev.cloud_plugs": "Cloud sockets",
  "header.title.dev.delta_green": "Delta Green",
  "header.title.dev.electree": "Electree",
  "header.title.dev.enerco": "Enerco",
  "header.title.dev.energomachine": "Energomachine",
  "header.title.dev.inverter_config": "Inverter configuration",
  "header.title.dev.mqtt_broker": "MQTT Broker",
  "header.title.dev.mqtt_cloud": "MQTT Cloud",
  "header.title.dev.pre_flexibility": "PRE Flexibility",
  "header.title.dev.scripts": "Scripts",
  "header.title.dev.shellies": "Shellies",
  "header.title.dev.spot": "Spot",
  "header.title.dev.status_log": "Status log",
  "header.title.dev.subscriptions": "Subscriptions",
  "header.title.dev_homepage": "Development Menu",
  "header.title.ems": "EMS",
  "header.title.ems_service": "EMS Service",
  "header.title.energyMeters": "Energy Meters",
  "header.title.expert_service": "Expert Service",
  "header.title.expert_service.network": "Network Settings",
  "header.title.grid": "Grid",
  "header.title.heat_pump": "Heat pump",
  "header.title.photovoltaics": "Photovoltaics",
  "header.title.plug": "Socket",
  "header.title.relay": "Relay",
  "header.title.reports": "Reports",
  "header.title.rfid_cards": "RFID cards",
  "header.title.settings": "Settings",
  "header.title.spot": "Spot",
  "header.title.statistics": "Statistics",
  "header.title.thermostat": "Thermostat",
  "header.title.wallbox": "Wallbox",
  "header.title.wallbox_list": "Wallboxes",
  "header.title.wind": "Wind turbine",
  "heat_pump.HW": "Hot water heating",
  "heat_pump.HW.actual_temp": "Current tank temperature",
  "heat_pump.HW.flexitemp": "Flexible temperature",
  "heat_pump.HW.flexitemp.subtitle": "Temperature by which the hot water can be preheated",
  "heat_pump.HW.hysteresis": "Hysteresis of hot water heating",
  "heat_pump.HW.on": "Hot water heating",
  "heat_pump.HW.temp": "Desired boiler temperature",
  "heat_pump.acond": "Acond",
  "heat_pump.blocked": "Compressor blockage",
  "heat_pump.blocked.min_soc": "Compressor blockage",
  "heat_pump.blocked.min_soc_utility": "Compressor blockage when the grid is available",
  "heat_pump.blocked.subtitle": "Battery charge level at which the compressor is blocked during a power outage",
  "heat_pump.common": "General information",
  "heat_pump.common.power": "Total consumption",
  "heat_pump.common.power_today": "Today's consumption:",
  "heat_pump.common.power_year": "Annual consumption:",
  "heat_pump.common.temp": "Current temperature on the heat exchanger",
  "heat_pump.common.total": "Total consumption",
  "heat_pump.ecoone": "Ecoone",
  "heat_pump.flexi": "Energy flexibility",
  "heat_pump.flexi.flexi_on": "Flexibility mode",
  "heat_pump.flexi.flexi_on.subtitle": "Mode activates preheating from excess energy",
  "heat_pump.flexi.pvstability": "Compressor activation potential",
  "heat_pump.flexi_sp": "Spot flexibility",
  "heat_pump.flexi_sp.flexi_increase_on": "Increase consumption",
  "heat_pump.flexi_sp.flexi_increase_on.subtitle": "Mode allows increasing consumption at low energy prices",
  "heat_pump.flexi_sp.flexi_reduce_on": "Delay of consumption",
  "heat_pump.flexi_sp.flexi_reduce_on.subtitle": "Mode allows postponing consumption at high energy prices",
  "heat_pump.nibe": "Nibe",
  "heat_pump.room": "Heating",
  "heat_pump.room.equithermalCorrection": "Heating curve adjustment",
  "heat_pump.room.flexitemp": "Flexible temperature",
  "heat_pump.room.flexitemp.subtitle": "Temperature by which the house can be preheated or pre-cooled",
  "heat_pump.room.on": "Heating",
  "heat_pump.room.tem": "Desired temperature",
  "heat_pump.room.temp": "Current room temperature",
  "heat_pump.room.tempmax": "Desired comfort temperature",
  "heat_pump.room.tempmin": "Desired attenuation temperature",
  "heat_pump.room_cool.on": "Cooling",
  "heat_pump.status": "Heat mode",
  "heat_pump_wizard.cancel": "Cancel",
  "heat_pump_wizard.ip_address.alert": "Please make sure that the IP address of the heat pump will not change (e.g. when the heat pump uses an address from DHCP).",
  "heat_pump_wizard.ip_address.input": "IP address of the heat pump",
  "heat_pump_wizard.open": "Set up the type of heat pump",
  "heat_pump_wizard.save": "Save",
  "heat_pump_wizard.title": "Settings of the heat pump",
  "heatpump.statistics": "Statistics",
  "heatpump.status": "Heat pump mode",
  "home.premium.banner.inactive.subtitle": "Infigy Plus provides more detailed charts, monthly reports, notifications and much more.",
  "home.premium.banner.inactive.title": "Do you want a better overview?",
  "homepage.actual.battery": "Battery status",
  "homepage.actual.boiler": "Boiler",
  "homepage.actual.outdoor_temperature": "Outdoor temperature",
  "homepage.actual.thermostat": "Thermostat",
  "homepage.actual.title": "",
  "homepage.animation": "Currently",
  "homepage.statuses.title": "Active component modes",
  "homepage.statuses.tooltip": "Active component modes",
  "homepage.today.consumed": "House consumption",
  "homepage.today.consumed_WB": "Wallbox",
  "homepage.today.consumed_from_grid": "Consumption from the grid",
  "homepage.today.consumed_hp": "Heat pump",
  "homepage.today.consumed_hw": "Heat water",
  "homepage.today.overflow": "Overflow to the grid",
  "homepage.today.photovoltaics": "Photovoltaics production",
  "homepage.today.title": "Daily statistics",
  "homepage.today.wind": "Wind turbine production",
  "hp.status.compressor_blocked": "Compressor blockage, low battery level",
  "hp.status.cooling": "Cooling",
  "hp.status.heating": "Heating",
  "hp.status.hot_water": "Hot water heating",
  "hp.status.inactive": "Inactive",
  "hp.status.not_connected": "Cannot establish connection",
  "hp.status.not_licensed": "Heat pump is not licensed",
  "hp.status.pool": "Pool heating",
  "hp.sub_status.consumption_postpone": "when consumption is reduced",
  "hp.sub_status.consumption_rise": "when consumption is increased",
  "hp.sub_status.consumption_with_flexibility": "with flexibility",
  "hp.sub_status.nibe_not_writable": "- cannot write to NIBE",
  "hp.sub_status.none": "",
  "initial_wizard.banner.button": "Start wizard",
  "initial_wizard.banner.hide.confirm": "Do you really want to hide the wizard?",
  "initial_wizard.banner.hide.confirm.description": "You can restart the wizard at any time in the application settings.",
  "initial_wizard.banner.hide.show_more": "Start wizard",
  "initial_wizard.banner.hide.yes": "Hide",
  "initial_wizard.banner.subtitle": "The wizard will help you set up the basic parameters of your system.",
  "initial_wizard.banner.title": "Complete initial setup",
  "initial_wizard.banner.title.completed": "Complete initial setup",
  "initial_wizard.dialog.finish": "Finish",
  "initial_wizard.dialog.next": "Next",
  "initial_wizard.dialog.prev": "Back",
  "initial_wizard.dialog.step": "Step {current} of {total}",
  "initial_wizard.dialog.title": "Initial setup wizard",
  "initial_wizard.step1.description.active": "Your access to the service is already active. You can proceed to the next step.",
  "initial_wizard.step1.password_info": "Each company has its own access password to the service menu. You received the password in the email communication. You can also view it at any time in app.infigy.cz in the partner section.",
  "initial_wizard.step1.title": "Access to the service",
  "initial_wizard.step1.welcome": "Welcome to the initial setup of Infigy. We will guide you through the basic configuration of your system. Detailed settings can then be found in the service menu.",
  "initial_wizard.step10.title": "Wallbox settings",
  "initial_wizard.step11.description": "You have completed the basic setup of Infigy. All parameters can be edited in the service menu.",
  "initial_wizard.step11.service_menu.subtitle": "Settings -> all the way down -> Access to the service",
  "initial_wizard.step11.service_menu.title": "Service menu",
  "initial_wizard.step11.title": "Done",
  "initial_wizard.step2.title": "Application update",
  "initial_wizard.step3.title": "Installation",
  "initial_wizard.step4.title": "Main circuit breaker settings",
  "initial_wizard.step5.title": "Inverter connection",
  "initial_wizard.step6.title": "Inverter parameters",
  "initial_wizard.step7.description": "If the overflow to the network is limited, the settings are transferred to the inverter. Limiting overflows ensures the inverter. However, Infigy controls the value according to the value set in this field. Do not modify the overflow limit in the inverter. When setting up for the first time, check the value written in the inverter to see if it is correctly transferred from Infigy to the inverter.",
  "initial_wizard.step7.title": "Overflow limit",
  "initial_wizard.step8.title": "Boiler settings",
  "initial_wizard.step9.title": "Spot trading settings",
  "initial_wizard.step_app_update.description": "At the time when Infigy was on its way to you, we could release new versions of the application. We recommend updating the unit before setting it up. However, if for example the internet is not available, you can skip the update and perform it later in the service menu, or in the portal.",
  "inverter.3mar_plc": "3Mar PLC",
  "inverter.az_router": "AzRouter energy meter",
  "inverter.control.mode": "Inverter control",
  "inverter.control.mode.chargingFromGrid": "Battery charging from grid",
  "inverter.control.mode.dischargingToGrid": "Battery discharging to grid",
  "inverter.control.mode.noneControl": "No control",
  "inverter.control.mode.stopCharging": "Stop charging",
  "inverter.control.mode.stopDischarging": "Stop discharging",
  "inverter.control.mode.stopOverflow": "Stop overflow",
  "inverter.des_battery_container": "DES - container storage",
  "inverter.deye": "Deye LV",
  "inverter.deye_hv": "Deye HV",
  "inverter.fronius": "Fronius SYMO GEN24",
  "inverter.fronius_grid": "Fronius SYMO grid",
  "inverter.fronius_verto": "Fronius Verto",
  "inverter.good_we": "GoodWe",
  "inverter.good_we_grid_next": "GoodWe grid",
  "inverter.good_we_next": "GoodWe",
  "inverter.goodwe-Grid": "Goodwe grid tie",
  "inverter.goodwe_grid": "Goodwe grid",
  "inverter.hes": "HES - battery storage",
  "inverter.next": "More inverters",
  "inverter.none": "None",
  "inverter.sermatec": "Sermatec",
  "inverter.shellies": "Shellies",
  "inverter.shellies_external": "Shellies External",
  "inverter.sma_grid": "SMA grid",
  "inverter.sofar_solar": "Sofarsolar",
  "inverter.sofar_solar_rs485": "SofarSolar RS485",
  "inverter.solar_edge_grid": "SolarEdge on-grid",
  "inverter.solax": "Solax",
  "inverter.solax-Grid": "Solax grid tie",
  "inverter.solax_ems1000": "Solax EMS1000",
  "inverter.solax_ems1000pro": "Solax EMS1000PRO",
  "inverter.solax_grid": "Solax on-grid",
  "inverter.solax_mega_grid": "Solax MEGA/FORTH on-grid",
  "inverter.solax_mic_grid": "Solax MIC on-grid",
  "inverter.solax_next": "SolaxNext",
  "inverter.solinteg": "Solinteg",
  "inverter.victron": "Victron",
  "inverter.wattsonic": "Wattsonic",
  "inverter_wizard.cancel": "Cancel",
  "inverter_wizard.custom_device_ip_address.alert": "Please make sure that the inverter IP address will not change (e.g. when the inverter uses an address from DHCP).",
  "inverter_wizard.custom_device_ip_address.input": "IP address of the inverter",
  "inverter_wizard.multiple_inverters.alert": "Please contact the support line for setting up multiple inverters. Contact can be found in the technical wiki Infigy.",
  "inverter_wizard.multiple_inverters.label": "Multiple inverters",
  "inverter_wizard.multiple_inverters_or_ems.alert": "Your system already has settings for multiple inverters or EMS. This guide is intended only for setting up one inverter. For changes in the settings of inverters or EMS, please contact support.",
  "inverter_wizard.nominal_power": "Nominal power of the inverter",
  "inverter_wizard.nominal_power.helper": "Range: 1 to 100 kW",
  "inverter_wizard.nominal_power.validation": "Enter the nominal power of the inverter in kW.",
  "inverter_wizard.open": "Find inverter",
  "inverter_wizard.save": "Save",
  "inverter_wizard.scan": "Find inverter on the network",
  "inverter_wizard.scanning": "Searching for inverter on the network",
  "inverter_wizard.submit_error": "An error occurred while saving the inverter settings. Please try again.",
  "inverter_wizard.title": "Inverter connection guide",
  "layout.disconnected": "Disconnected",
  "layout.pigpio_init_error_dialog.description": "The Infigy application did not start properly. Please restart the device and if the problem persists, contact support.",
  "layout.pigpio_init_error_dialog.title": "Error when starting the application",
  "level.thermostat.cooling": "Cooling",
  "level.thermostat.deactivated": "Deactivated",
  "level.thermostat.heating": "Heating",
  "level.thermostat.standby": "Standby",
  "level.thermostat.tempErr": "Temperature Error",
  "level.thermostatFlexibility.increasePv": "Flexibility used to increase temperature according to photovoltaics",
  "level.thermostatFlexibility.increaseSpot": "Flexibility used to increase temperature according to SPOT",
  "level.thermostatFlexibility.normal": "Normal",
  "level.thermostatFlexibility.reductionSpot": "Flexibility used to reduce temperature according to SPOT",
  "mqtt_broker.connected_clients.title": "Clients",
  "mqtt_broker.enabled": "Enabled",
  "mqtt_broker.running": "Status",
  "mqtt_broker.title": "MQTT Broker",
  "mqtt_cloud.connected": "Status",
  "mqtt_cloud.connected.offline": "Offline",
  "mqtt_cloud.connected.online": "Online",
  "mqtt_cloud.enabled": "Integration enabled",
  "mqtt_cloud.title": "MQTT Cloud",
  "nav.app_messages": "Messages",
  "nav.home": "Home",
  "nav.logout": "Log out",
  "nav.reports": "Reports",
  "nav.sec.boiler": "Boiler",
  "nav.sec.cloud_plugs": "Sockets",
  "nav.sec.ems": "EMS",
  "nav.sec.energyMeters": "Energy Meters",
  "nav.sec.grid": "Grid",
  "nav.sec.heatpump": "Heat pump",
  "nav.sec.home": "General",
  "nav.sec.photovoltaics": "Photovoltaics",
  "nav.sec.plug": "Socket",
  "nav.sec.relay": "Relay",
  "nav.sec.spot": "Spot",
  "nav.sec.thermostat": "Thermostat",
  "nav.sec.wallbox": "Wallbox",
  "nav.sec.wind": "Wind turbine",
  "nav.settings": "Settings",
  "nav.statistics": "Statistics",
  "network.ethernet_ports": "Ethernet ports",
  "network.ethernet_ports.name": "LAN",
  "network.ethernet_ports.status": "Status",
  "network.ethernet_ports.status.down": "Inactive",
  "network.ethernet_ports.status.up": "Active",
  "network.scan.error": "Network scan failed",
  "network.summary.address": "IP address",
  "network.summary.dhcp_host_exists": "Address fixed on DHCP. Click to unfix.",
  "network.summary.error": "Error when loading",
  "network.summary.heat_pump": "Heat pump",
  "network.summary.inverter": "Inverter",
  "network.summary.mac": "MAC",
  "network.summary.name": "Name",
  "network.summary.no_dhcp_host": "Dynamic address on DHCP. Click to fix.",
  "network.summary.not_connected": "Not connected",
  "network.title": "General",
  "network.wan_address": "WAN address",
  "network_wan_edit.dialog.address": "IP address",
  "network_wan_edit.dialog.close": "Close",
  "network_wan_edit.dialog.dns": "DNS server",
  "network_wan_edit.dialog.gateway": "Default gateway",
  "network_wan_edit.dialog.netmask": "Network mask",
  "network_wan_edit.dialog.save": "Save",
  "network_wan_edit.dialog.title": "Edit WAN address",
  "nmap.empty": "Nothing found",
  "nmap.error": "Scan failed",
  "nmap.host": "Address",
  "nmap.loading": "Scanning",
  "nmap.output": "Output",
  "nmap.port": "Port",
  "nmap.port.help": "Empty = only device search",
  "nmap.range.external": "external — customer network",
  "nmap.range.internal": "internal — Infigy network",
  "nmap.result.address": "IP address",
  "nmap.result.mac": "MAC address",
  "nmap.result.ports": "Ports",
  "nmap.result.scanning": "Scanning {target}, may take a while…",
  "nmap.result.target": "Scanned range: {target}",
  "nmap.result.vendor": "Vendor",
  "nmap.start": "Start",
  "nmap.target": "Address or range",
  "nmap.target.help": "Named network or IP / range",
  "nmap.title": "Port scan",
  "photovoltaics.battery": "Battery",
  "photovoltaics.battery.battery_charged": "Battery charging",
  "photovoltaics.battery.battery_manual_discharge": "Manually discharge battery",
  "photovoltaics.battery.battery_power": "Battery power",
  "photovoltaics.battery.soc_actual": "Calculated minimum charge",
  "photovoltaics.batteryStatus": "BMS status",
  "photovoltaics.battery_stop": "Battery blocking",
  "photovoltaics.battery_stop.hdo": "Discharge battery only at low tariff (HDO)",
  "photovoltaics.battery_stop.hp": "Block battery when operating the heat pump",
  "photovoltaics.battery_stop.hw": "Block battery when operating the hot water heater",
  "photovoltaics.battery_stop.wb": "Block battery when operating the wallbox",
  "photovoltaics.battery_stop.wb.lock_desc": "When the wallbox charging mode „Charge according to battery“ is enabled, this blocking cannot be enabled. After enabling the blocking, set another wallbox charging mode.",
  "photovoltaics.battery_stop.wb.lock_title": "Setting cannot be changed",
  "photovoltaics.common": "General information",
  "photovoltaics.common.battery_charged": "Battery charging",
  "photovoltaics.common.battery_manual_charge": "Charge the battery manually",
  "photovoltaics.common.battery_manual_charge_soc": "Target SOC for manual charging",
  "photovoltaics.common.battery_manual_charge_subtitle": "Manual charging of the battery will charge the battery to the target level of charge if it is not turned off earlier by the user.",
  "photovoltaics.common.battery_manual_discharge": "Manually discharge the battery",
  "photovoltaics.common.battery_manual_discharge_subtitle": "Manual discharging of the battery will discharge the battery to the minimum level of charge if it is not turned off earlier by the user.",
  "photovoltaics.common.battery_power": "Battery performance",
  "photovoltaics.common.power": "Current performance",
  "photovoltaics.common.power_today": "Today's production:",
  "photovoltaics.common.power_total": "Total production",
  "photovoltaics.common.power_year": "Annual production:",
  "photovoltaics.common.string1": "String 1:",
  "photovoltaics.common.string2": "String 2:",
  "photovoltaics.common.string3": "String 3:",
  "photovoltaics.common.string4": "String 4:",
  "photovoltaics.common.string5": "String 5:",
  "photovoltaics.common.string6": "String 6:",
  "photovoltaics.statistics": "Statistics",
  "photovoltaics.statistics.charge": "Battery charging",
  "photovoltaics.statistics.discharge": "Battery discharging",
  "photovoltaics.statisticsSoc": "Battery level",
  "photovoltaics.status": "Photovoltaics mode",
  "ping.address": "Address",
  "ping.output": "Output",
  "ping.start": "Start",
  "ping.stop": "Stop",
  "ping.title": "Ping",
  "plug.bat": "Control by battery",
  "plug.bat.batterySart": "Turn on when charging",
  "plug.bat.batterySart.help": "Battery level at which the socket turns on. For the socket to turn on, the battery level must change from the set state to a higher state. If the value is set to 80%, the socket turns on when the battery is charged from 80% to 81%.",
  "plug.bat.batterySart.subtitle": "Battery charging which activates the outlet",
  "plug.bat.batteryStop": "Turn off when charging",
  "plug.bat.batteryStop.help": "Battery level at which the socket turns off. For the socket to turn off, the battery level must change from the set state to a lower state. If the value is set to 80%, the socket turns off when the battery is discharged from 80% to 79%.",
  "plug.bat.batteryStop.subtitle": "Charging the battery, which turns off the socket",
  "plug.bat.help": "Turning on at a defined battery level. Can be combined with a time condition. If one of the conditions for turning on is met, the socket turns on, and if one of the conditions for turning off is met, the socket turns off.",
  "plug.bat.on": "Active",
  "plug.main": "General information",
  "plug.main.consumption": "Current consumption",
  "plug.main.power": "total consumption",
  "plug.main.power_today": "Today's consumption:",
  "plug.main.power_year": "Annual consumption:",
  "plug.main.stat": "Statistics",
  "plug.overflow": "Control by overflow",
  "plug.overflow.consumption": "Setting corresponds to a device with power consumption",
  "plug.overflow.help": "Turning on the socket at a defined overflow into the distribution network. Can be combined with a time condition. If one of the conditions for turning on is met, the socket turns on, and if one of the conditions for turning off is met, the socket turns off.",
  "plug.overflow.on": "Active",
  "plug.overflow.startPower": "Turn on at grid consumption",
  "plug.overflow.startPower.help": "The socket turns on if the overflow is at the set level after a defined delay. If the value is set to - 1500W and the turn-on delay is 5 minutes, the socket turns on when the overflow into the network is at least 1500W for 5 minutes.",
  "plug.overflow.startPower.subtitle": "Negative value is overflow",
  "plug.overflow.stopPower": "Turn off at grid consumption",
  "plug.overflow.stopPower.help": "The socket turns off if the consumption is higher than the set level after a defined delay. If the value is set to 100W and the turn-off delay is 5 minutes, the socket turns off when the consumption from the network is at least 100W for 5 minutes.",
  "plug.overflow.stopPower.subtitle": "Negative value is overflow, positive value is consumption",
  "plug.overflow.time": "Turn on and off delay",
  "plug.overflow.time.help": "This parameter is used to define the delay for turning on and off the socket at defined overflows/consumptions. Suitable for setting priority and elimination of frequent socket switching. Enter in the format HH:MM.",
  "plug.plug": "Socket",
  "plug.spot": "Control by spot price",
  "plug.spot.15m.period": "Spot price period",
  "plug.spot.15m.period.subtitle": "15 minute intervals",
  "plug.spot.help": "Turning on at a defined spot price. Can be combined with a time condition. If one of the conditions for turning on is met, the socket turns on, and if one of the conditions for turning off is met, the socket turns off.",
  "plug.spot.on": "Active",
  "plug.spot.period": "Spot price period",
  "plug.spot.period.subtitle": "60 minute intervals",
  "plug.spot.price.period": "Socket time resolution",
  "plug.spot.spotHi": "Activate at high price",
  "plug.spot.spotHi.help": "The socket turns on if the spot price is at the high level (see the Spot tab).",
  "plug.spot.spotLow": "Activate at a low price",
  "plug.spot.spotLow.help": "The socket turns on if the spot price is at the low level (see the Spot tab).",
  "plug.spot.spotMi": "Activate at mid price",
  "plug.spot.spotMi.help": "The socket turns on if the spot price is at the middle level (see the Spot tab).",
  "plug.spot.spot_above_price": "Activate at a higher price than the set price",
  "plug.spot.spot_above_price.help": "The socket turns on if the spot price is higher or equal to the set spot price.",
  "plug.spot.spot_above_price.subtitle": "The socket turns on if the spot price is higher or equal to the set spot price. If it is lower, the socket turns off.",
  "plug.spot.spot_below_price": "Activate at a lower price than the set price",
  "plug.spot.spot_below_price.help": "The socket turns on if the spot price is lower or equal to the set spot price.",
  "plug.spot.spot_below_price.subtitle": "The socket turns on if the spot price is lower or equal to the set spot price. If it is higher, the socket turns off.",
  "plug.spot.spot_neg": "Activate at negative price",
  "plug.spot.spot_neg.help": "The socket turns on if the spot price is negative (see the Spot tab).",
  "plug.status": "Socket mode",
  "plug.summary.price": "Price",
  "plug.summary.price_level": "Price level",
  "plug.summary.price_level_15m": "Price level 15m",
  "plug.summary.switch": "Socket switch",
  "plug.summary.time": "Time",
  "plug.time": "Control by time",
  "plug.time.help": "Turning on at a defined time. Can be combined with other conditions depending on the battery (must be installed), spot price (must be allowed for spot trading) and overflow (must be allowed for overflow into the network). If one of the conditions for turning on is met, the socket turns on, and if one of the conditions for turning off is met, the socket turns off.",
  "plug.time.on": "Active",
  "plug.time.turn_off": "Turn off at a defined time",
  "plug.time.turn_off.help": "Time at which the socket turns off. If set to 12:00, the socket turns off exactly at the set time 12:00.",
  "plug.time.turn_on": "Turn on at a defined time",
  "plug.time.turn_on.help": "Time at which the socket turns on. If set to 12:00, the socket turns on exactly at the set time 12:00.",
  "plug.turn_off": "Turn off",
  "plug.turn_on": "Turn on",
  "pre_flexibility.business_flexibility.title": "Business flexibility",
  "pre_flexibility.enabled": "Integration enabled",
  "pre_flexibility.title": "PRE Flexibility",
  "premium.banner.active.button": "Manage subscription",
  "premium.banner.active.dev_mode": "Subscription is active for development",
  "premium.banner.active.subtitle": "The Infigy Plus subscription is active. You can enjoy all the features that are extra in the application thanks to it.",
  "premium.banner.active.title": "Subscription is active",
  "premium.banner.hide.confirm": "Do you really want to hide Infigy Plus banner?",
  "premium.banner.hide.confirm.description": "You can always view Infigy Plus again in the application settings.",
  "premium.banner.hide.later": "Remind me later",
  "premium.banner.hide.show_more": "Learn more",
  "premium.banner.hide.yes": "Hide",
  "premium.banner.inactive.button": "Learn more",
  "premium.banner.inactive.subtitle": "Take your energy management to the next level. With Infigy Plus you get even more smart tools - detailed graphs, instant notifications, enhanced calendar, detailed reports and more.",
  "premium.banner.inactive.title": "Infigy Plus is not active",
  "premium.dialog.charts.subtitle": "Get the opportunity to track the performance of individual strings, consumption by phase and other detailed information.",
  "premium.dialog.charts.title": "Detailed graphs",
  "premium.dialog.close": "Close",
  "premium.dialog.next.subtitle": "We are preparing a lot of additional benefits that we will gradually release for Infigy Plus subscribers",
  "premium.dialog.next.title": "Additional benefits will soon arrive",
  "premium.dialog.notifications.subtitle": "Get notifications about negative prices, charged battery and other events",
  "premium.dialog.notifications.title": "Notifications",
  "premium.dialog.other_benefits.subtitle": "We are preparing a lot of additional benefits that we will gradually release for Infigy Plus subscribers",
  "premium.dialog.other_benefits.title": "Additional benefits will soon arrive",
  "premium.dialog.reports.subtitle": "Detailed monthly reports that give you a clear picture of production, consumption and energy use in your household. All important data is in one place - clearly, clearly and supplemented by graphs.",
  "premium.dialog.reports.title": "Advanced reports",
  "premium.dialog.save": "Subscribe to Infigy Plus",
  "premium.dialog.schedule.subtitle": "Schedule manually charging or discharging the battery as needed",
  "premium.dialog.schedule.title": "Enhanced calendar",
  "premium.dialog.spot.subtitle": "Get the opportunity to look into the history of spot prices and plans that Infigy prepared in the past",
  "premium.dialog.spot.title": "History of spot prices",
  "protocol.settings": "Settings",
  "protocol.settings.Licence": "License",
  "protocol.settings.distribution": "License",
  "protocol.test": "Device test",
  "protocol.test.internet-connect": "Internet connection",
  "protocol.test.inverter-connect": "Connecting the inverter",
  "protocol.test.phase_1": "Phase 1 test",
  "protocol.test.phase_2": "Phase 2 test",
  "protocol.test.phase_3": "Phase 3 test",
  "protocol.test.tester": "Device tested by",
  "relay.condition": "Turning on condition",
  "relay.main": "General information",
  "relay.name": "Relay name",
  "relay.spot.diagram": "Control by spot price",
  "relay.status": "Status",
  "relay.summary.switch": "Relay switch",
  "relay.title": "Relay",
  "report.avg_day_chart.battery_soc": "Battery state of charge",
  "report.avg_day_chart.consumption": "Consumption",
  "report.avg_day_chart.grid": "Grid",
  "report.avg_day_chart.pv_production": "PV production",
  "report.not_generated": "Create report by clicking",
  "report_test.button": "Test",
  "report_test.date": "Month (e.g. 2025-09)",
  "report_test.generated": "Report generated",
  "report_test.ok": "OK",
  "report_test.test": "Test",
  "reports.accumulation_increased": "Accumulation increased",
  "reports.average_water_temperature": "Average water temperature",
  "reports.avg_day": "Average day",
  "reports.battery": "Battery",
  "reports.boiler": "Electric boiler",
  "reports.building_consumption": "Building consumption",
  "reports.disclaimer": "The values have only an informative character and may differ from the official readings of the distributor.",
  "reports.energy_estimate": "Energy estimate without control",
  "reports.estimated_water_amount": "Estimated water amount",
  "reports.grid_consumption": "Grid consumption",
  "reports.grid_consumption_hp": "Grid consumption for heat pump",
  "reports.grid_consumption_hw": "Grid consumption for electric boiler",
  "reports.grid_consumption_wallbox": "Grid consumption for wallbox",
  "reports.heat_pump": "Heat pump",
  "reports.household_consumption": "Household consumption",
  "reports.info": "General information",
  "reports.kilometers_driven": "Number of kilometers driven",
  "reports.kilometers_driven_from_sun": "Number of kilometers driven from the sun",
  "reports.maximum_power": "Maximum power",
  "reports.monthly_consumption": "Monthly consumption",
  "reports.monthly_production": "Monthly production",
  "reports.pv": "Photovoltaic plant",
  "reports.pv_consumption": "PV consumption",
  "reports.pv_production": "PV production",
  "reports.regenerate_report": "Regenerate report",
  "reports.regenerate_report_confirm_title": "Regenerate report?",
  "reports.rfid_cards": "RFID cards",
  "reports.self_consumption": "Self-consumption",
  "reports.self_sufficiency": "Self-sufficiency",
  "reports.self_sufficient_days": "Number of self-sufficient days",
  "reports.share.description": "You can share the selected screenshot with others.",
  "reports.share.share": "Share report",
  "reports.share.title": "Share report",
  "reports.share_report": "Share report",
  "reports.sold_to_distribution_grid": "Sold to grid",
  "reports.stored_energy_from_grid": "Stored energy from grid",
  "reports.stored_energy_from_pv": "Stored energy from PV",
  "reports.stored_energy_to_battery": "Stored energy to battery",
  "reports.stored_energy_to_boiler": "Stored energy to electric boiler",
  "reports.stored_energy_to_heat_pump": "Stored energy to heat pump",
  "reports.stored_energy_to_wallbox": "Stored energy to wallbox",
  "reports.total_overflow_to_grid": "Total overflow to grid",
  "reports.total_purchase_from_grid": "Total purchase from grid",
  "reports.total_with_control": "Total with control",
  "reports.total_without_control": "Total without control",
  "reports.updated_at": "Generated {date}",
  "reports.wallbox": "EV charging station (wallbox)",
  "rfid_cards.col.consumption": "Consumption",
  "rfid_cards.col.created_at": "Added",
  "rfid_cards.col.id": "Card ID",
  "rfid_cards.col.name": "Name",
  "rfid_cards.export": "Export CSV",
  "rfid_cards.from": "From",
  "rfid_cards.no_cards": "No cards added",
  "rfid_cards.title": "RFID cards",
  "rfid_cards.to": "To",
  "save": "Save",
  "schedules.add": "Add schedule",
  "schedules.add.tooltip": "Add",
  "schedules.battery_charge": "Battery charging",
  "schedules.battery_discharge": "Battery discharging",
  "schedules.charging_current": "Charging current: {chargingCurrent} A",
  "schedules.description": "Schedule manually charging or discharging the battery as needed.",
  "schedules.dialog.title": "Scheduler",
  "schedules.dialog.title.ev": "Create charging plan",
  "schedules.ev_charging": "EV charging",
  "schedules.form.action": "Action",
  "schedules.form.battery_charge": "Charge battery",
  "schedules.form.battery_discharge": "Discharge battery",
  "schedules.form.charging-current": "Set charging current",
  "schedules.form.charging-current.auto": "Default",
  "schedules.form.close": "Close",
  "schedules.form.create": "Create",
  "schedules.form.duration": "Duration (minutes)",
  "schedules.form.duration.120min": "2 hours",
  "schedules.form.duration.180min": "3 hours",
  "schedules.form.duration.240min": "4 hours",
  "schedules.form.duration.300min": "5 hours",
  "schedules.form.duration.360min": "6 hours",
  "schedules.form.duration.60min": "1 hour",
  "schedules.form.ev_charging": "EV charging",
  "schedules.form.frequency": "Frequency  ",
  "schedules.form.frequency.daily": "Daily",
  "schedules.form.frequency.monthly": "Monthly",
  "schedules.form.frequency.weekly": "Weekly",
  "schedules.form.interval.biweekly": "Every 2 weeks",
  "schedules.form.preview.hide": "Hide preview",
  "schedules.form.preview.show": "Show scheduled occurrences",
  "schedules.form.preview.title": "Scheduled starts ({count} following)",
  "schedules.form.recurring": "Recurring",
  "schedules.form.target-soc": "Target SOC (optional)",
  "schedules.form.until": "Repeat until (optional)",
  "schedules.form.when": "When",
  "schedules.loading.error": "Error loading schedules",
  "schedules.missed": "Missed",
  "schedules.no_plans_found": "No plans found.",
  "schedules.processed": "Processed",
  "schedules.remove.confirm": "Do you really want to delete the plan?",
  "schedules.remove.no": "Cancel",
  "schedules.remove.recurring.instance": "Delete only this occurrence",
  "schedules.remove.recurring.series": "Delete entire series",
  "schedules.remove.recurring.title": "Delete recurring plan",
  "schedules.remove.yes": "Delete",
  "schedules.running": "Running",
  "schedules.scheduled": "Scheduled",
  "schedules.show_processed": "Show processed",
  "schedules.target_soc": "Target SOC: {targetSoc, number, percent}",
  "schedules.title": "Scheduler",
  "scripts.add": "Create",
  "scripts.delete": "Delete",
  "scripts.edit": "Edit",
  "scripts.loading_error": "Error loading scripts",
  "scripts.title": "Scripts",
  "settings.PV.NominalInverterPower": "Nominal inverter power",
  "settings.PV.NominalInverterPower.help": "This is important for the correct % calculation of overflows for Solinteg, Wattsonic and Deye.",
  "settings.PV.NominalInverterPower.subtitle": "Nominal inverter power in kW, important for the % calculation of overflows into the network.",
  "settings.PV.StringNumber": "Number of inverter strings",
  "settings.PV.StringNumber.subtitle": "Number of inverter strings displayed in the PV tab in the application",
  "settings.app_update": "Application version",
  "settings.app_update.check_button": "Check for updates",
  "settings.app_update.confirm.cancel": "Cancel",
  "settings.app_update.confirm.confirm": "Update",
  "settings.app_update.confirm.description": "Update may take a few minutes. During the update, the application will be unavailable and will then automatically restart.",
  "settings.app_update.confirm.title": "Start update?",
  "settings.app_update.error.no_internet": "Check your internet connection",
  "settings.app_update.in_progress": "Update in progress",
  "settings.app_update.request_button": "Update is available",
  "settings.app_update.requested": "Update was requested",
  "settings.app_update.subtitle": "Check for new versions",
  "settings.app_update.title": "Application update",
  "settings.app_update.up_to_date": "Application is up to date",
  "settings.boiler": "Electric boiler",
  "settings.boiler.3phase": "Three-phase electric boiler",
  "settings.boiler.3phase.subtitle": "Connect a single-phase electric boiler to the SSR output matching the selected phase.",
  "settings.boiler.HwBatteryPriority": "Percentage of battery charging from which the boiler starts heating",
  "settings.boiler.HwBatteryPriority.help": "If the battery charge is lower than this value, the energy accumulation priority is fully available to the battery. If the battery charge is higher, the boiler starts taking priority and starts heating the water from the excess energy of the PV - part of the energy goes further into the battery to be discharged.",
  "settings.boiler.capacity": "Boiler volume",
  "settings.boiler.capacity_sub": "Required for spot trading only",
  "settings.boiler.enabled": "Electric boiler installed",
  "settings.boiler.hysterezis": "Boiler hysteresis",
  "settings.boiler.hysterezis.subtitle": "Hysteresis is only for regular heating",
  "settings.boiler.nominal": "Rated power",
  "settings.boiler.nominal.subtitle": "Nominal input for 1 phase of the electric boiler",
  "settings.boiler.phase": "Boiler phase",
  "settings.boiler.phase.subtitle": "L1 = SSR output 1, L2 = SSR output 2, L3 = SSR output 3.",
  "settings.boiler.prio": "Battery priority",
  "settings.boiler.prio.subtitle": "If ON, the battery is charged first, then the boiler",
  "settings.boiler.shellies": "Boiler is controlled through Shelly",
  "settings.boiler.temp_enabled": "Temperature sensor installed",
  "settings.boiler.temp_enabled.subtitle": "The boiler can only be used for surpluses without a sensor",
  "settings.device": "Device",
  "settings.device.SN": "Serial number",
  "settings.device.id": "Device ID",
  "settings.device.license": "Device license",
  "settings.docs": "Guides and other materials",
  "settings.docs.service_settings_inverter.button": "Go to wiki",
  "settings.docs.service_settings_inverter.subtitle": "Documentation, procedures, and other information",
  "settings.docs.service_settings_inverter.title": "Guide on connecting the inverter",
  "settings.docs.tech_wiki.button": "Go to wiki",
  "settings.docs.tech_wiki.subtitle": "Guides, procedures, and other information",
  "settings.docs.tech_wiki.title": "Technical wiki",
  "settings.docs.user_wiki.button": "Go to wiki",
  "settings.docs.user_wiki.subtitle": "Guides, procedures, and other information",
  "settings.docs.user_wiki.title": "User wiki",
  "settings.hdo": "Setting of remote time control system",
  "settings.hdo.help": "Setting of HDO times for the calculation of electricity prices in the high and low tariff. Below you can set the times of the low tariff.",
  "settings.hdo.on1": "Time 1",
  "settings.hdo.on2": "Time 2",
  "settings.hdo.on3": "Time 3",
  "settings.hdo.on4": "Time 4",
  "settings.hdo.on5": "Time 5",
  "settings.hdo.on6": "Time 6",
  "settings.hdo.regular": "Regular working day",
  "settings.hdo.start": "Start",
  "settings.hdo.stop": "Stop",
  "settings.hdo.type": "Define times for",
  "settings.hdo.weekend": "Weekend HDO times",
  "settings.heatpump": "Installation",
  "settings.heatpump.HpBatteryPriority": "Percentage of battery state of charge (SOC) from which the heat pump power increases",
  "settings.heatpump.HpBatteryPriority.help": "If the battery charge is lower than this value, the energy accumulation priority is fully available to the battery. If the battery charge is higher, the heat pump starts taking priority and starts heating the water from the excess energy of the PV - part of the energy goes further into the battery to be discharged.",
  "settings.heatpump.enabled": "Heat pump installed",
  "settings.heatpump.flexiAN": "Accumulation tank's flexibility",
  "settings.heatpump.flexiCool": "Cooling flexibility",
  "settings.heatpump.flexiHw": "Hot water flexibility",
  "settings.heatpump.flexiRoom": "Room flexibility",
  "settings.heatpump.hp_type": "Type of heat pump",
  "settings.heatpump.nominal": "Nominal input power",
  "settings.heatpump.nominal1": "Nominal input power",
  "settings.heatpump.priority": "The heat pump has a higher priority than the battery",
  "settings.heatpump.priority-wb": "Heat pump has a higher priority than the wallbox",
  "settings.heatwatter": "Boiler",
  "settings.heatwatter.legionella": "Legionella",
  "settings.heatwatter.legionella_temp": "Sanitation temperature",
  "settings.heatwatter.legionella_temp.subtitle": "Temperature to which the boiler must be heated at least once every 14 days",
  "settings.inverter_communication_status": "Inverter communication",
  "settings.inverter_communication_status.not_ok": "Not connected,{br}trying to connect...",
  "settings.inverter_communication_status.ok": "Communication established{br}({count} readings)",
  "settings.inverter_communication_status.subtitle": "Establishing communication may take several tens of seconds to several minutes",
  "settings.notification": "Notifications",
  "settings.notification.application_settings": "Notifications - parameters",
  "settings.notification.battery_max_soc": "Maximum SOC battery",
  "settings.notification.battery_max_soc.subtitle": "Notification will be generated when the maximum SOC of the battery is reached. Notification will be generated only once a day.",
  "settings.notification.battery_max_soc_value": "Maximum SOC battery for notifications",
  "settings.notification.battery_max_soc_value.subtitle": "Set the SOC of the battery, at which a notification will be generated.",
  "settings.notification.battery_min_soc": "Minimum SOC battery",
  "settings.notification.battery_min_soc.subtitle": "Notification will be generated when the SOC of the battery drops to the set minimum value. Notification will be generated only once a day.",
  "settings.notification.battery_min_soc_value": "Minimum SOC battery for notifications",
  "settings.notification.battery_min_soc_value.subtitle": "Set the SOC of the battery, at which a notification will be generated.",
  "settings.notification.daily_prediction.subtitle": "Notification will be generated every day at 8:00",
  "settings.notification.description": "Permission to generate notifications that will be generated in the application",
  "settings.notification.heat_pump_limit_exceeded": "Exceeding the limit of heat pump consumption",
  "settings.notification.heat_pump_limit_exceeded.subtitle": "Notification will be generated when the limit of heat pump consumption is exceeded",
  "settings.notification.heat_pump_limit_value": "Daily limit of heat pump consumption for notifications",
  "settings.notification.heat_pump_limit_value.subtitle": "Set the limit of heat pump consumption, at which a notification will be generated.",
  "settings.notification.heat_water_limit_exceeded": "Exceeding the limit of heating water",
  "settings.notification.heat_water_limit_exceeded.subtitle": "Notification will be generated when the limit of heating water is exceeded",
  "settings.notification.heat_water_limit_value": "Daily limit of heating water for notifications",
  "settings.notification.heat_water_limit_value.subtitle": "Set the limit of heating water, at which a notification will be generated.",
  "settings.notification.heat_water_max_temperature": "The maximum temperature of the water has been reached",
  "settings.notification.heat_water_max_temperature.subtitle": "Notification will be generated when the maximum temperature of the water in the boiler from PV energy is reached",
  "settings.notification.home_consumption_limit_exceeded": "Exceeding the limit of home consumption",
  "settings.notification.home_consumption_limit_exceeded.subtitle": "Notification will be generated when the limit of home consumption is exceeded",
  "settings.notification.home_consumption_limit_value": "Daily limit of home consumption for notifications",
  "settings.notification.home_consumption_limit_value.subtitle": "Set the limit of home consumption, at which a notification will be generated.",
  "settings.notification.iverter_disconnected": "Communication with the inverter has been lost",
  "settings.notification.iverter_disconnected.subtitle": "Notification will be generated at the beginning and end of the communication loss with the inverter",
  "settings.notification.negative_spot": "Negative price on the spot",
  "settings.notification.negative_spot.subtitle": "Notification will be generated at the beginning and end of the negative price on the spot",
  "settings.notification.pv_production_mwh": "PV production milestone",
  "settings.notification.pv_production_mwh.subtitle": "Notification will be generated if the PV generates MWh of energy in the given year",
  "settings.notification.spot_charging_battery": "Start and stop battery charging according to the spot price",
  "settings.notification.spot_charging_battery.subtitle": "Notification will be generated at the beginning and end of the battery charging according to the spot price",
  "settings.notification.spot_daily_prediction": "Daily prediction",
  "settings.notification.spot_daily_summary": "Daily summary of the spot plan",
  "settings.notification.spot_daily_summary.subtitle": "Notification will be generated every day at 8:00",
  "settings.notification.spot_discharging_battery": "Start and stop battery discharging to the grid according to the spot price",
  "settings.notification.spot_discharging_battery.subtitle": "Notification will be generated at the beginning and end of the battery discharging to the grid according to the spot price",
  "settings.notification.utility_loss": "Grid outage",
  "settings.notification.utility_loss.subtitle": "Notification will be generated at the beginning and end of the utility loss",
  "settings.notification.wallbox_charging_start_stop": "Start and stop charging the electric vehicle",
  "settings.notification.wallbox_charging_start_stop.subtitle": "Notification will be generated at the beginning and end of the electric vehicle charging",
  "settings.notification.wallbox_limit_exceeded": "Exceeding the limit of charging the electric vehicle",
  "settings.notification.wallbox_limit_exceeded.subtitle": "Notification will be generated when the limit of charging the electric vehicle is exceeded",
  "settings.notification.wallbox_limit_value": "Daily limit of charging the electric vehicle for notifications",
  "settings.notification.wallbox_limit_value.subtitle": "Set the limit of charging the electric vehicle, at which a notification will be generated.",
  "settings.notification.webapp.subtitle": "You can receive notifications from Infigy via the web application.",
  "settings.notification.webapp.title": "Web application",
  "settings.other": "Other",
  "settings.other.dark_mode": "Dark mode",
  "settings.other.languate": "Language",
  "settings.other.overflow_fronius": "Maximum overflow into the network is limited on the side of the Fronius inverter",
  "settings.other.overflow_fronius_subtitle": "This value is set by the distributor. Exceeding this value may lead to financial penalties from the distributor.",
  "settings.other.overflow_settings": "Set overflow value",
  "settings.other.overflow_settings.help": "This is a service-set value of the maximum overflow. This value is set by the distributor. Exceeding this value may lead to financial penalties from the distributor.",
  "settings.other.readability_mode": "Font size",
  "settings.photovoltaics": "Photovoltaics",
  "settings.photovoltaics.backup_enabled": "Backup enabled",
  "settings.photovoltaics.backup_enabled.subtitle": "Information about the backup mode of the inverter.",
  "settings.photovoltaics.batterychargingpower": "Battery charging power",
  "settings.photovoltaics.batterychargingpower_sub": "Power for manual battery charging and spot charging from the grid",
  "settings.photovoltaics.batterydischargingpower": "Battery discharging power",
  "settings.photovoltaics.batterydischargingpower_sub": "Power for spot discharging of the battery to the grid",
  "settings.photovoltaics.batteryenabled": "Battery installed",
  "settings.photovoltaics.batterynominal": "Nominal battery capacity",
  "settings.photovoltaics.batterynominal_sub": "Required for spot trading only",
  "settings.photovoltaics.enabled": "Photovoltaics installed",
  "settings.photovoltaics.gridchargeenabled": "Battery charging from the distribution grid enabled",
  "settings.photovoltaics.inverters-adjust-power": "Current inverter power",
  "settings.photovoltaics.inverters-nominal": "Nominal power of adjustable inverters",
  "settings.photovoltaics.nominal": "Nominal power",
  "settings.photovoltaics.overflow": "Unlimited grid overflow",
  "settings.photovoltaics.overflow.value": "Overflow limitation",
  "settings.photovoltaics.overflow.value.help": "Value of the maximum overflow into the network. This value is written to the inverter. Do not modify this value in the inverter. The overflow limitation is controlled by Infigy. Check the written value in the inverter.",
  "settings.photovoltaics.overflow_fronius.value.help": "Value of the maximum overflow into the network on the side of the Fronius inverter. It is used as information for Infigy to correctly visualize overflows.",
  "settings.photovoltaics.settings": "Battery",
  "settings.photovoltaics.settings.soc_actual": "Calculated minimum charge",
  "settings.photovoltaics.settings.soc_actual.help": "This value is automatically calculated based on the current state. It is either controlled by automatic charging according to the annual period, or by manual setting of the minimum charge with DS and without DS. If the value is 100%, then battery charging is prohibited, e.g. according to spot trading.",
  "settings.photovoltaics.settings.soc_grid": "Minimum charge with DS",
  "settings.photovoltaics.settings.soc_grid.help": "With this value, you can control the minimum charge of the battery in % SOC when the distribution network is available. In Solax in the Backup mode, the minimum charge of the battery is 15%.",
  "settings.photovoltaics.settings.temp": "Minimum charge with Grid",
  "settings.photovoltaics.settings.temp.help": "With this value, you can control the minimum charge of the battery in % SOC when the distribution network is available.",
  "settings.photovoltaics.settings.temp_ek": "Minimum charge without Grid",
  "settings.photovoltaics.settings.temp_ek.help": "With this value, you can control the minimum charge of the battery in % SOC when the distribution network is unavailable.",
  "settings.photovoltaics.unbalanced_enabled": "Asymmetry of the inverter",
  "settings.photovoltaics.unbalanced_enabled.subtitle": "Information about the asymmetry of the inverter.",
  "settings.photovoltaics_auto_settings": "Automatic charge control",
  "settings.photovoltaics_auto_settings.subtitle": "Automatic minimum SOC control according to the annual period",
  "settings.plug": "Sockets",
  "settings.plug.Led": "Permanent backlight",
  "settings.plug.Led-batt": "Backlight when the battery is charged",
  "settings.plug.Led-batt.subtitle": "Backlight active if the battery is at least 95%",
  "settings.plug.Led-over": "Backlight during overflow",
  "settings.plug.enabled": "Sockets installed",
  "settings.plug.enabled.subtitle": "Sockets on the local network",
  "settings.plug.enabled2": "Second socket",
  "settings.plug.enabled3": "Third socket",
  "settings.plug.ip1": "The IP address of the first socket",
  "settings.plug.ip1.label": "IP 3",
  "settings.plug.ip2": "The IP address of the second socket",
  "settings.plug.ip2.label": "IP 2",
  "settings.plug.ip3": "The IP address of the third socket",
  "settings.plug.ip3.label": "IP 3",
  "settings.plug.modulenabled": "Sockets on the module",
  "settings.plug.modulip": "IP address of the module",
  "settings.plug.modulip.label": "IP Module",
  "settings.plug.name1": "Name of socket 1",
  "settings.plug.name1.label": "Name",
  "settings.plug.name2": "Name of socket 2",
  "settings.plug.name2_label": "Name",
  "settings.plug.name3": "Name of socket 3",
  "settings.plug.name3.label": "Name",
  "settings.plug.statusLed": "Signal diode",
  "settings.readability_mode.default": "Default",
  "settings.readability_mode.large": "Large",
  "settings.relay": "Relay",
  "settings.relay.0.enabled": "First relay",
  "settings.relay.1.enabled": "Second relay",
  "settings.relay.1.type": "Condition",
  "settings.relay.1.type.HDO": "Mirror HDO",
  "settings.relay.1.type.batteryfull": "Battery charged above 95%",
  "settings.relay.1.type.batterylow": "Battery charged below set minimum",
  "settings.relay.1.type.bojlerFull": "Boiler is almost heated",
  "settings.relay.1.type.none": "Not used",
  "settings.relay.1.type.plug1": "Socket 1",
  "settings.relay.1.type.plug2": "Socket 2",
  "settings.relay.1.type.plug3": "Socket 3",
  "settings.relay.1.type.spotHi": "High spot price",
  "settings.relay.1.type.spotLow": "Low spot price",
  "settings.relay.1.type.spotMi": "Medium spot price",
  "settings.relay.1.type.spotNegative": "Negative spot price",
  "settings.relay.1.type.thermostat1": "Thermostat circuit 1",
  "settings.relay.1.type.thermostat2": "Thermostat circuit 2",
  "settings.relay.1.type.thermostat3": "Thermostat circuit 3",
  "settings.relay.1.type.thermostat4": "Thermostat circuit 4",
  "settings.relay.2.enabled": "Third relay",
  "settings.relay.3.enabled": "Fourth relay",
  "settings.relay.above_price_relay": "Spot price for the relay to activate",
  "settings.relay.above_price_relay.subtitle": "If the spot price is higher than this value, the relay turns on. If it is lower, the relay turns off.",
  "settings.relay.above_price_relay_15m": "Spot price for the relay to activate (15 min)",
  "settings.relay.above_price_relay_15m.subtitle": "If the spot price is higher than this value, the relay turns on. If it is lower, the relay turns off.",
  "settings.relay.above_soc_relay": "Battery charge for the relay to activate",
  "settings.relay.above_soc_relay.subtitle": "If the battery charge is higher than this value, the relay turns on.",
  "settings.relay.above_soc_relay_hyst": "Hysteresis of the battery SOC for the relay to deactivate",
  "settings.relay.above_soc_relay_hyst.subtitle": "If the battery charge decreases by this value below the set activation value, the relay turns off.",
  "settings.relay.below_price_relay": "Spot price for the relay to activate",
  "settings.relay.below_price_relay.subtitle": "If the spot price is lower than this value, the relay turns on. If it is higher, the relay turns off.",
  "settings.relay.below_price_relay_15m": "Spot price for the relay to activate (15 min)",
  "settings.relay.below_price_relay_15m.subtitle": "If the spot price is lower than this value, the relay turns on. If it is higher, the relay turns off.",
  "settings.relay.below_soc_relay": "Battery charge for the relay to activate",
  "settings.relay.below_soc_relay.subtitle": "If the battery charge decreases by this value below the set activation value, the relay turns off.",
  "settings.relay.below_soc_relay_hyst": "Hysteresis of the battery SOC for the relay to deactivate",
  "settings.relay.below_soc_relay_hyst.subtitle": "If the battery charge increases by this value above the set activation value, the relay turns off.",
  "settings.relay.enabled": "Relays installed",
  "settings.relay.enabled.subtitle": "Integrated relays",
  "settings.relay.item.enabled": "Relay {index}",
  "settings.relay.item.name": "Relay name",
  "settings.relay.item.status": "Status",
  "settings.relay.option": "Condition",
  "settings.relay.temp_above_relay.subtitle": "If the boiler temperature is higher than this value, the relay turns on.",
  "settings.relay.temp_above_relay_hyst.subtitle": "If the boiler temperature decreases by this value below the set activation value, the relay turns off.",
  "settings.relay.temp_below_relay.subtitle": "If the boiler temperature is lower than this value, the relay turns on.",
  "settings.relay.temp_below_relay_hyst": "Hysteresis of the boiler °C temperature for the relay to deactivate",
  "settings.relay.temp_below_relay_hyst.subtitle": "If the boiler temperature increases by this value above the set activation value, the relay turns off.",
  "settings.relay.temp_relay": "Boiler temperature for the relay to activate",
  "settings.relay.temp_relay_hyst": "Hysteresis of the boiler °C temperature for the relay to deactivate",
  "settings.relay.type.Active": "Permanent on",
  "settings.relay.type.HDO": "Mirror HDO",
  "settings.relay.type.batteryBelowSOC": "Battery charge below the set SOC",
  "settings.relay.type.batteryDischarge": "Battery discharging to the grid",
  "settings.relay.type.batteryFull": "Battery charge above the set SOC",
  "settings.relay.type.batteryLow": "Battery charge below the set minimum",
  "settings.relay.type.bojlerFull": "Boiler is almost heated",
  "settings.relay.type.hdo": "Mirror HDO",
  "settings.relay.type.heatWaterAboveTemp": "Boiler is heated above the set temperature",
  "settings.relay.type.heatWaterBelowTemp": "Boiler is heated below the set temperature",
  "settings.relay.type.heatWaterMaxTemp": "Boiler is almost heated",
  "settings.relay.type.heatWaterTemp": "Boiler is heated above the set temperature",
  "settings.relay.type.none": "Not used, permanently off",
  "settings.relay.type.plug1": "Socket 1",
  "settings.relay.type.plug2": "Socket 2",
  "settings.relay.type.plug3": "Socket 3",
  "settings.relay.type.plug4": "Socket 4",
  "settings.relay.type.spotBatteryDischarge": "Battery discharging to the grid",
  "settings.relay.type.spotHi": "High spot price",
  "settings.relay.type.spotHi15M": "High spot price (15 min)",
  "settings.relay.type.spotLow": "Low spot price",
  "settings.relay.type.spotLow15M": "Low spot price (15 min)",
  "settings.relay.type.spotMi": "Medium spot price",
  "settings.relay.type.spotMi15M": "Medium spot price (15 min)",
  "settings.relay.type.spotNegative": "Limitation of overflows to the network",
  "settings.relay.type.spotNegative15M": "Prohibition of overflows to the electrical grid (15 min)",
  "settings.relay.type.spotPriceAbove": "Spot price above the set value",
  "settings.relay.type.spotPriceAbove15M": "Spot price above the set value (15 min)",
  "settings.relay.type.spotPriceBelow": "Spot price below the set value",
  "settings.relay.type.spotPriceBelow15M": "Spot price below the set value (15 min)",
  "settings.relay.type.spotStopAccumulation": "Accumulation stopped, active sale",
  "settings.relay.type.stopAccumulation": "Accumulation stopped, active sale",
  "settings.relay.type.thermostat1": "Thermostat 1",
  "settings.relay.type.thermostat2": "Thermostat 2",
  "settings.relay.type.thermostat3": "Thermostat 3",
  "settings.relay.type.thermostat4": "Thermostat 4",
  "settings.relay.user_advanced_control": "Show page with information for the user",
  "settings.relay.user_advanced_control.subtitle": "When enabled, a page appears in the navigation",
  "settings.service": "Service",
  "settings.service.connection_type": "Connection",
  "settings.service.customer": "Username",
  "settings.service.customer-email": "User email",
  "settings.service.customer-email-subtitle": "If the user does not have an account under this email, an account will be automatically created and a registration email will be sent",
  "settings.service.customer-email.label": "E-mail",
  "settings.service.customer-subtitle": "Used to identify the installation for the company and the customer",
  "settings.service.customer.label": "Name",
  "settings.service.exit": "Sign out of the service",
  "settings.service.exit.button": "Log out",
  "settings.service.info": "Installation",
  "settings.service.inverter_type": "Inverter type",
  "settings.service.inverter_type.label": "Inverter",
  "settings.service.modbus_tcp": "LAN/WiFi",
  "settings.service.network": "Network",
  "settings.service.network.help.content": "The list shows devices currently connected to the Infigy network (WiFi or cable), their IP addresses, MAC addresses, etc. If a device uses DHCP, you can click on the pin to fix the IP address, which the DHCP server will always assign - this is useful for devices like inverters, heat pumps, etc. If a device uses a static IP address, it may not display correctly.",
  "settings.service.network.help.title": "Network Settings",
  "settings.service.network.mac": "MAC address",
  "settings.service.network.online.internet": "Access to the internet",
  "settings.service.network.online.internet.help": "Access to the internet is required for remote access, system updates, spot prices and other functions. For full functionality, all three indicators must be green.{br}{br}The first indicator shows the availability of the internet (ping 8.8.8.8).{br}{br}The second indicator shows the availability of the internet including DNS (ping infigy.cz).{br}{br}The third indicator shows access to the internal cloud services of Infigy (VPN availability).{br}{br}If there is a problem with the connection, please check the cable or contact the network administrator, if the local network has restrictions on communication to the internet.{br}{br}{wikiLink}",
  "settings.service.network.online.internet.help.wikiLink": "More information in our wiki.",
  "settings.service.network.online.portal": "Access to the Infigy portal",
  "settings.service.network.wan": "WAN address",
  "settings.service.network.wifi_passphrase": "WiFi Network Password",
  "settings.service.network_type": "Network",
  "settings.service.network_type.custom": "Manual address setting",
  "settings.service.network_type.external": "Local network (customer)",
  "settings.service.network_type.internal": "Internal Infigy network",
  "settings.service.password": "Access to service",
  "settings.service.password.label": "Password",
  "settings.service.relay": "Relay",
  "settings.service.reset": "Error reset",
  "settings.service.reset.button": "Error reset",
  "settings.service.rs485": "RS485",
  "settings.service.service-email": "Service company email",
  "settings.service.service-email-subtitle": "To link the device with the installation account, it is necessary to enter the service company's email, which is stored in the Partner section of the application",
  "settings.service.service-email.label": "E-mail",
  "settings.service.servicer": "Name of installer",
  "settings.service.servicer.label": "Name",
  "settings.service.solidsun_op": "SolidSun OP",
  "settings.service.solidsun_op.label": "SolidSun OP",
  "settings.service.spot": "Spot trading",
  "settings.service.tester.label": "Name of tester",
  "settings.service.thermostat": "Thermostat",
  "settings.service.town": "Location (village)",
  "settings.service.version": "Application version",
  "settings.service.wallbox_type": "Wallbox type",
  "settings.service.wallbox_type.label": "Wallbox",
  "settings.spot": "Spot trading",
  "settings.spot.battery": "Allowed battery charging by spot",
  "settings.spot.battery.stop_discharge_auto": "Automatic discharge prohibition control",
  "settings.spot.battery.stop_discharge_auto.help": "If you select this option, the system will automatically control the battery discharge and allow it only at the highest daily spot prices.",
  "settings.spot.battery.stop_discharge_auto.subtitle": "Controlling the storage of energy automatically at the highest price",
  "settings.spot.battery.stop_discharge_hi_price": "Prohibit battery discharge at low and medium prices",
  "settings.spot.battery.stop_discharge_high_price": "Prohibit battery discharge at low and medium prices",
  "settings.spot.battery.stop_discharge_high_price.help": "If you select this option, the system will not use energy from the battery at low and medium spot prices. The system will not discharge the battery. It will be used at higher prices.",
  "settings.spot.battery.stop_discharge_low_price": "Prohibit battery discharge at low prices",
  "settings.spot.battery.stop_discharge_low_price.help": "If you select this option, the system will not use energy from the battery at low spot prices. The system will not discharge the battery. It will be used at higher prices (medium and high price).",
  "settings.spot.battery.stop_discharge_low_price.subtitle": "Controlling the storage of energy at medium and high price",
  "settings.spot.battery.stop_discharge_middle_price.subtitle": "Controlling the storage of energy at high price",
  "settings.spot.batteryAllOverflowPrice": "Minimum price for discharging the entire battery capacity",
  "settings.spot.batteryOverflow": "Allow battery discharge to the grid according to spot prices",
  "settings.spot.batteryOverflowPrice": "Minimum price for battery discharge",
  "settings.spot.batterySale": "Allowed battery discharge to the grid according to spot prices",
  "settings.spot.battery_all_overflow_price": "Minimum price for discharging the entire battery capacity",
  "settings.spot.battery_all_overflow_price.help": "If the spot price is higher than this value, the battery capacity will be discharged to the grid up to the set minimum SOC. This means that the energy will not be stored in the battery for night and morning consumption. The energy will be purchased for the object's consumption from the grid after discharging the battery to the grid.",
  "settings.spot.battery_all_overflow_price.subtitle": "The energy is stored in the battery for daily consumption",
  "settings.spot.battery_charge": "Allowed battery charging by spot",
  "settings.spot.battery_charge.help": "If you select this option, the system will schedule charging at the lowest prices. It takes into account the current level of battery charge and its capacity. Based on these parameters, it will select the charging duration to charge the battery at the lowest possible price.",
  "settings.spot.battery_charge.subtitle": "Controlling the battery according to spot increases the battery depreciation",
  "settings.spot.battery_max_soc": "Final SOC of the battery",
  "settings.spot.battery_max_soc.subtitle": "Maximum charging of the battery when charging from the grid",
  "settings.spot.battery_overflow": "Allow battery discharge to the grid according to spot prices",
  "settings.spot.battery_overflow.help": "If you select this option, the system will schedule battery discharge to the grid at the highest daily price and discharge only the energy that is not needed for the daily consumption of the object. The parameters below can define the price for discharging the entire battery capacity and discharging only the part of the battery capacity that is not needed for night consumption.",
  "settings.spot.battery_overflow.subtitle": "Allows discharging the excess energy in the battery to the grid in the most favorable hour",
  "settings.spot.battery_overflow_price": "Minimum price for discharging the battery",
  "settings.spot.battery_overflow_price.help": "If the spot price is higher than this value, the excess battery capacity will be discharged to the grid. This means that the energy will be stored in the battery for night and morning consumption. The energy will not be purchased for the object's consumption from the grid.",
  "settings.spot.battery_overflow_price.subtitle": "The energy is stored in the battery for night consumption",
  "settings.spot.battery_strategy": "Strategy for spot charging of the battery",
  "settings.spot.battery_strategy.help": "With this slider, you can easily set the preference for using the battery in spot trading. Lower values (from 20 %) mean less battery cycling and therefore less frequent charging/discharging according to spot prices. Higher values (up to 70 %) mean the opposite.",
  "settings.spot.battery_strategy_service.subtitle": "With this option, you allow the end users to set the battery strategy on the Spot tab",
  "settings.spot.battery_strategy_user": "Allow setting the battery strategy by the user",
  "settings.spot.battery_strategy_user.subtitle": "With this option, you allow the end users to set the battery strategy on the Spot tab",
  "settings.spot.install": "Spot trading active",
  "settings.spot.latitude": "Latitude",
  "settings.spot.latitude.mess": "Width",
  "settings.spot.longitude": "Longitude",
  "settings.spot.longitude.mess": "Length",
  "settings.spot.min_difference_price_charge_from_grid": "Minimum difference in spot price for charging the battery from the grid",
  "settings.spot.min_difference_price_charge_from_grid.help": "With this parameter, you can control the battery charging from the spot at a low difference between the lowest and highest price. If the parameter is 2 CZK and the difference between the highest price (3 CZK) and the lowest price (1 CZK) of the spot is lower, then the battery charging from the spot is not scheduled.",
  "settings.spot.min_difference_price_charge_from_grid.subtitle": "Minimum difference in spot price during the day, for the battery to be charged from the grid",
  "settings.spot.overflow": "Allow overflow optimization according to spot prices",
  "settings.spot.overflow.help": "If you select this option, the system prioritizes overflow to the grid before battery charging at higher and medium spot prices. This happens only in annual periods, in which we expect an excess of energy from PV and usually in the morning. Optimization does not take place at low spot prices, when the priority is charging the battery from PV.",
  "settings.spot.overflow.subtitle": "Allows prioritizing overflow before accumulation",
  "settings.spot.overflow_offset": "Maximum overflow at negative price",
  "settings.spot.overflow_offset.help": "The value indicates the overflow to the distribution network at a negative price. We recommend using this function in the case of an energy community.",
  "settings.spot.overflow_offset.subtitle": "The value cannot be set higher than the maximum overflow",
  "settings.spot.price.period": "Time period",
  "settings.spot.price_above_price": "Set spot price",
  "settings.spot.price_below": "Set spot price",
  "settings.spot.price_distribution_hi": "Price of the grid power at high tariff",
  "settings.spot.price_distribution_hi.help": "Price of the grid power at high tariff per kWh. This price is added to the spot price, if the high tariff is active. The HDO times must be set for the correct calculation of the price in the high and low tariff. This amount can be found in the electricity bill.",
  "settings.spot.price_distribution_low": "Price of the grid power at low tariff",
  "settings.spot.price_distribution_low.help": "Price of the grid power at low tariff per kWh. This price is added to the spot price, if the low tariff is active. The HDO times must be set for the correct calculation of the price in the high and low tariff. This amount can be found in the electricity bill.",
  "settings.spot.price_offset": "The price of prohibiting overflows",
  "settings.spot.price_offset.help": "We recommend setting at least the commission/fee of the trader for selling overflows to the network.",
  "settings.spot.price_offset.subtitle": "Minimum spot price, under which overflows are prohibited. The value is compared with the daily market without the distribution tariff.",
  "settings.spot.region": "Region",
  "settings.thermostat.hp-blocked": "Blocking of the heat pump",
  "settings.thermostat.hysteresis": "Temperature hysteresis",
  "settings.thermostat.install": "Thermostat active",
  "settings.thermostat.name.label": "Name",
  "settings.thermostat.name1": "Thermostat 1 name",
  "settings.thermostat.name2": "Thermostat 2 name",
  "settings.thermostat.name3": "Thermostat 3 name",
  "settings.thermostat.name4": "Thermostat 4 name",
  "settings.thermostat.nominal": "Nominal power of the source",
  "settings.thermostat.number-of-thermostat": "Number of thermostats",
  "settings.utility": "House parameters",
  "settings.utility.loadpercent": "Current circuit breaker load",
  "settings.utility.numberofphase": "Three-phase installation",
  "settings.utility.settings.ampers": "Circuit breaker size",
  "settings.utility.settings.loadpercent": "When exceeded, consumption is limited",
  "settings.utility.settings.loadpercent_max": "When exceeded, consumption is limited",
  "settings.wallbox": "Wallbox",
  "settings.wallbox.install": "Wallbox active",
  "settings.wallbox.name": "Name of the wallbox {number}",
  "settings.wallbox.spot": "Wallbox",
  "settings.wallbox.type": "Wallbox type",
  "shellies.energyMeters": "Energy Meters",
  "shellies.energyMeters.add": "Add",
  "shellies.energyMeters.empty": "No energy meters configured",
  "shellies.energyMeters.list": "Energy Meters Configuration",
  "shellies.energyMeters.name": "Name",
  "shellies.energyMeters.newMeter": "New meter",
  "shellies.energyMeters.shellyId": "Shelly ID",
  "shellies.list": "Shellies",
  "shellies.mqtt_broker_running": "MQTT Broker status",
  "shellies.settings": "Settings",
  "shellies.settings.boiler.active": "Boiler connected via Shellies",
  "shellies.settings.boiler.id": "ID of Shellies",
  "shellies.settings.boiler.id.label": "ID",
  "shellies.title": "Shellies",
  "spot.chartview": "Display the price without the distribution fee",
  "spot.draft": "Modes for today",
  "spot.draft.actualpricehi": "The current price is high, reduce consumption",
  "spot.draft.actualpricelow": "The current price is low, increase consumption",
  "spot.draft.hesLevel": "Level of HES control",
  "spot.draft.hiprice": "Limits of reduced consumption",
  "spot.draft.info": "Modes and recommendations for today",
  "spot.draft.lowprice": "The limit of increased consumption",
  "spot.draft.todaystatus_HP": "Heat pump accumulation",
  "spot.draft.todaystatus_HW": "Hot water accumulation",
  "spot.draft.todaystatus_bat": "Battery accumulation",
  "spot.draft.todaystatus_em": "Overflow",
  "spot.explanation": "Explanation of modes",
  "spot.explanation.battery_discharge_to_grid": "Discharging the battery to the grid",
  "spot.explanation.battery_discharge_to_home": "Discharging the battery",
  "spot.explanation.hw": "Charging the battery from the grid",
  "spot.explanation.info": "Detailed explanation of modes for today",
  "spot.flexibility": "Flexibility estimate for today",
  "spot.prediction": "Consumption estimate for today",
  "spot.prediction.bat": "Dispositional battery accumulation",
  "spot.prediction.battery": "Dispositional battery accumulation",
  "spot.prediction.home": "Normal consumption of the house",
  "spot.prediction.hp": "Heat pump",
  "spot.prediction.hw": "Dispositional hot water accumulation",
  "spot.prediction.pv": "Photovoltaics production",
  "spot.prediction.sale": "Energy for sale",
  "spot.prediction.sale.help": "Remaining planned daily overflow, which will be prioritized as overflow to the grid before battery accumulation.",
  "spot.price.period.15min": "15 min",
  "spot.price.period.60min": "60 min",
  "spot.region.cz": "CZ",
  "spot.region.nl": "NL",
  "spot.region.sk": "SK",
  "spot.status": "Spot trading",
  "spot.summary.battery_charge_from_grid": "Charging from the grid",
  "spot.summary.battery_charge_from_grid.help": "Charging the battery from the grid according to the spot price can be enabled or disabled in the settings. The system schedules battery charging during low prices, considering the current battery level and its capacity. Based on these parameters, it determines the charging duration to charge the battery at the lowest cost.",
  "spot.summary.battery_discharge": "Battery discharge",
  "spot.summary.battery_discharge.help": "Discharging the battery to the house according to the spot price can be enabled or disabled in the settings. Discharging is usually disabled during low prices when it is better to use energy from the grid and save the battery for higher price periods.",
  "spot.summary.battery_discharge_to_grid": "Discharge to the grid",
  "spot.summary.battery_discharge_to_grid.help": "Discharging the battery to the grid can be enabled or disabled in the settings. The system schedules battery discharge to the grid during the highest daily prices, discharging only the energy that will not be needed for the house's regular consumption.",
  "spot.summary.boiler": "Boiler",
  "spot.summary.boiler.help": "The system schedules boiler heating during low prices, considering the current water temperature, boiler capacity, and desired temperature. Based on these parameters, it determines the heating duration to heat the boiler.",
  "spot.summary.heat_pump": "Heat pump",
  "spot.summary.heat_pump.help": "The heat pump can operate in three modes: increased performance, normal operation, and reduced performance. Increased performance is used during low prices, normal operation during medium prices, and reduced performance during high prices. Consumption delay or increase can be enabled in the heat pump menu.",
  "spot.summary.heat_pump_level.increase": "Increased performance",
  "spot.summary.heat_pump_level.normal": "Normal operation",
  "spot.summary.heat_pump_level.reduction": "Reduced performance",
  "spot.summary.price": "Price",
  "spot.summary.price_buy": "Price with distribution",
  "spot.summary.price_distribution": "Distribution",
  "spot.summary.price_level": "Price level",
  "spot.summary.price_level.help": "Infigy sorts hourly spot prices from lowest to highest and divides them into three approximately equal parts. If hourly prices range from 3 CZK to 10 CZK, the low price range might be 3-6 CZK, medium 6-7 CZK, and high 7-10 CZK. The range will vary daily, depending on the frequency of values in each price level.",
  "spot.summary.price_level.hi": "High price",
  "spot.summary.price_level.low": "Low price",
  "spot.summary.price_level.mid": "Medium price",
  "spot.summary.price_level_15m": "Price level 15m",
  "spot.summary.price_sell": "Price without distribution",
  "spot.summary.spotOverflow": "Overflow to the grid",
  "spot.summary.spotOverflow.allowed": "Allowed",
  "spot.summary.spotOverflow.help": "Allowing overflow to the grid during spot trading compares the spot price in a given hour and if it is lower than the price for prohibiting overflow from the settings, then the system automatically disables the overflow in that hour.",
  "spot.summary.spotOverflow.restricted": "Restricted",
  "spot.summary.state.active": "Active",
  "spot.summary.state.inactive": "Inactive",
  "spot.summary.time": "Time",
  "spot.user.parameters": "Parameters of spot trading",
  "spot_wizard.banner.button": "Want help? I can help you",
  "spot_wizard.banner.subtitle": "The guide will help you set up spot trading.",
  "spot_wizard.banner.title": "Need help? I can help you",
  "spot_wizard.battery_discharge.paragraph1": "This setting disables battery discharge at low spot prices. This way you keep energy for higher prices during the day.",
  "spot_wizard.battery_discharge.paragraph2": "If you only sell energy on the spot, you can disable the prohibition.",
  "spot_wizard.battery_discharge.title": "Discharging the battery to your own consumption",
  "spot_wizard.battery_purchase.paragraph1": "This setting allows charging the battery from the lowest spot price when the production is low.",
  "spot_wizard.battery_purchase.paragraph2": "Pay attention to the strategy setting. If you set 20%, Infigy will mostly wait for photovoltaics. On the other hand, if you set 70%, Infigy will mostly buy on the spot. We recommend setting 25%.",
  "spot_wizard.battery_purchase.paragraph3": "If you only sell energy on the spot, you can disable the charging.",
  "spot_wizard.battery_purchase.title": "Buying energy into the battery",
  "spot_wizard.boiler.paragraph1": "This setting allows heating the boiler from the lowest prices during the day to the set temperature. Infigy still maintains the basic temperature and uses the increase in temperature from the spot.",
  "spot_wizard.boiler.paragraph2": "It is also possible to block heating at medium or high prices.",
  "spot_wizard.boiler.paragraph3": "If you only sell energy on the spot, you can set the temperature to 10°C and disable the heating block.",
  "spot_wizard.boiler.title": "Heating the boiler",
  "spot_wizard.dialog.finish": "Finish",
  "spot_wizard.dialog.next": "Next",
  "spot_wizard.dialog.prev": "Previous",
  "spot_wizard.dialog.step": "Step {current} of {total}",
  "spot_wizard.dialog.title": "Guide to setting up spot trading",
  "spot_wizard.distribution_prices.title": "Enter the price for distribution in low and high price ranges",
  "spot_wizard.done.description": "You have completed the spot trading settings. All parameters can be edited in the bottom part of the Spot page, where you can also call this guide again.",
  "spot_wizard.done.title": "Done",
  "spot_wizard.evening_peak_discharge.paragraph1": "Infigy automatically estimates the energy consumption in the morning hours. The excess can be sold at the highest price of the day.",
  "spot_wizard.evening_peak_discharge.paragraph2": "If you only buy energy on the spot, you can disable the discharge.",
  "spot_wizard.evening_peak_discharge.title": "Discharging the battery in the evening peak",
  "spot_wizard.general_settings.title": "First general settings",
  "spot_wizard.hdo_times.title": "Setting HDO times determines the low price period",
  "spot_wizard.heat_pump.paragraph1": "This setting allows increasing the performance of the heat pump at low production and decreasing it at high prices.",
  "spot_wizard.heat_pump.paragraph2": "If you only sell energy on the spot, you can disable the delay and increase of consumption.",
  "spot_wizard.heat_pump.title": "Heat pump",
  "spot_wizard.info.button1": "Why is my battery not charging from the spot today?",
  "spot_wizard.info.button2": "Why is my battery not discharging to the spot today?",
  "spot_wizard.info.button3": "I need help with setting up",
  "spot_wizard.info.help1.title": "Why is my battery not charging from the spot today?",
  "spot_wizard.info.help2.title": "Why is my battery not discharging to the spot today?",
  "spot_wizard.info.title": "Information about spot trading",
  "spot_wizard.overflow_limit.paragraph1": "If you have spot only for buying energy, you can set -10 Kč. Overflow is limited to the maximum size set by the service technician.",
  "spot_wizard.overflow_limit.paragraph2": "If you have spot for selling energy, it is advantageous to stop accumulation at a price that corresponds to the commission of your supplier. The commission is usually 0.30 - 0.70 Kč/kWh.",
  "spot_wizard.overflow_limit.title": "Limitation of overflow to the grid",
  "spot_wizard.preferential_sale.paragraph1": "This function sets feed-in priority during the morning peak. Energy is preferentially sold to the grid instead of being stored in the battery, boiler, and heat pump. Accumulation is re-enabled at low prices or after selling the estimated surplus energy.",
  "spot_wizard.preferential_sale.paragraph2": "If you only buy energy on the spot, you can disable the function.",
  "spot_wizard.preferential_sale.title": "Preferential sale of energy",
  "statistics.battery.statistics": "Level of battery charging",
  "statistics.boiler.statistics": "Electric boiler heating",
  "statistics.electrical_grid.statistics": "Purchase from a grid",
  "statistics.electrical_grid.statistics_house_consumption": "Building consumption",
  "statistics.electrical_grid.statistics_overflow": "Overflow to a grid ",
  "statistics.heatpump.statistics": "Heat pump consumption",
  "statistics.outdoor_temperature.statistics": "Outdoor temperature",
  "statistics.photovoltaics.statistics": "Photovoltaics production",
  "statistics.plug.statistics": "Socket consumption",
  "statistics.wind.statistics": "Wind turbine production",
  "stats_delete.button": "Delete",
  "stats_delete.cancel": "Cancel",
  "stats_delete.confirm": "Delete",
  "stats_delete.confirm.title": "Do you really want to delete all statistics?",
  "stats_delete.title": "Delete all statistics",
  "stats_export.button": "Export",
  "stats_export.from": "From",
  "stats_export.metric": "Metric",
  "stats_export.title": "Export statistics",
  "stats_export.to": "To",
  "status.heatWater.flexibility": "Flexibility active, heating of hot water",
  "status.heatWater.heating": "Heating of hot water",
  "status.heatWater.hwError": "The boiler is fully heated or not available",
  "status.heatWater.inverterError": "Preheating is inactive, the inverter is not available",
  "status.heatWater.legionella": "Sanitation of water, legionella",
  "status.heatWater.notConnected": "Cannot establish connection",
  "status.heatWater.notLicensed": "Boiler control is not licensed",
  "status.heatWater.off": "Off",
  "status.heatWater.overload": "Overload of the network, heating stopped",
  "status.heatWater.pvHeating": "Heating from excess",
  "status.heatWater.smartMeterError": "Preheating of the boiler is inactive, the electric meter is not available",
  "status.heatWater.spotHeating": "Heating of hot water from the spot",
  "status.heatWater.stop": "Stop",
  "status.heatWater.stopHDO": "Heating blocked at high price",
  "status.heatWater.stopSOC": "Heating blocked, low battery level",
  "status.heatWater.stopSell": "Preheating blocked, sale of energy",
  "status.heatWater.tempError": "Temperature sensor is not available",
  "status.photovoltaic.dischargeBlockedByComponents": "Battery discharge paused due to consumption of selected technologies",
  "status.photovoltaic.dischargeBlockedByHDO": "Battery discharge paused, high tariff active (HDO)",
  "status.photovoltaic.discharging": "Discharging of the battery",
  "status.photovoltaic.distributionLimit": "Distribution limits power",
  "status.photovoltaic.feedInPriority": "Feed-in priority",
  "status.photovoltaic.flexibilityBatteryStop": "Flexibility active, battery charging and discharging stopped",
  "status.photovoltaic.flexibilityCharging": "Flexibility active, charging of the battery from the network",
  "status.photovoltaic.flexibilityDischarging": "Flexibility active, discharging of the battery to the network",
  "status.photovoltaic.flexibilityDoNotDischarge": "Flexibility active, prohibition of discharging the battery",
  "status.photovoltaic.flexibilityFeedInPriority": "Flexibility active, priority of overflow to the network",
  "status.photovoltaic.flexibilityOverflowRestricted": "Flexibility active, prohibition of overflow to the network",
  "status.photovoltaic.forcedOverflow": "Flexibility active, forced overflow to the network",
  "status.photovoltaic.idle": "Idle mode",
  "status.photovoltaic.manualCharging": "Manual charging of the battery",
  "status.photovoltaic.manualDischarging": "Manual discharging of the battery",
  "status.photovoltaic.noOverflowLimit": "No overflow limit",
  "status.photovoltaic.noneInverter": "Inverter type not set",
  "status.photovoltaic.notConnected": "Cannot establish connection",
  "status.photovoltaic.notLicensed": "PV control is not licensed",
  "status.photovoltaic.planCharge": "Planned charging of the battery",
  "status.photovoltaic.planDischarge": "Planned discharging of the battery",
  "status.photovoltaic.production": "Production of energy",
  "status.photovoltaic.sellBatteryEnergy": "Sale of energy from the battery",
  "status.photovoltaic.spotCharging": "Charging of the battery from the spot",
  "status.photovoltaic.spotStopDischarging": "Discharging stopped, low price on the spot",
  "status.photovoltaic.standby": "Stand-by mode",
  "status.photovoltaic.startUp": "Start-up mode",
  "status.plug.batteryControl": "Socket active according to battery",
  "status.plug.manualControl": "Socket active in manual mode",
  "status.plug.notActive": "Socket inactive",
  "status.plug.notConnected": "Cannot establish connection",
  "status.plug.overflowControl": "Socket active according to overflow",
  "status.plug.spotControl": "Socket active according to spot",
  "status.plug.stop": "Stop",
  "status.plug.timeControl": "Socket active according to time",
  "status.smartMeter.consumption": "Normal consumption of the house",
  "status.smartMeter.maxLoad": "Maximum consumption of the house",
  "status.smartMeter.none": "",
  "status.smartMeter.overflow": "Overflow energy to the grid",
  "status.smartMeter.overflowLimited": "Overflow limited due to negative price",
  "status.smartMeter.shortage": "Shortage of the distribution network",
  "status.spotBattery.flexibilityPV": "Flexibility used for PV",
  "status.spotBattery.flexibilitySpot": "Flexibility used for SPOT",
  "status.spotBattery.noData": "No data for control",
  "status.spotBattery.spotNotLicensed": "Spot is not licensed",
  "status.spotBatteryChargeFromGrid.batteryChargingNotActive": "Charging from the grid is not active",
  "status.spotBatteryChargeFromGrid.batteryChargingPlanned": "Today's charging is active",
  "status.spotBatteryChargeFromGrid.enoughPVEnergy": "Today's expected daily surplus for charging the battery",
  "status.spotBatteryChargeFromGrid.priceDifferenceTooLow": "Today's minimum price difference is not met",
  "status.spotBatteryChargeFromGrid.spotNotActive": "Spot trading is not active",
  "status.spotBatteryDischargeToGrid.batteryDischargingNotActive": "Discharging to the grid is not active",
  "status.spotBatteryDischargeToGrid.batteryDischargingPlanned": "Today's discharging is active",
  "status.spotBatteryDischargeToGrid.minPriceNotReached": "Today's minimum price for sale is not met",
  "status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy": "Today's expected discharge of the battery through the night into own consumption",
  "status.spotBatteryDischargeToGrid.spotNotActive": "Spot trading is not active",
  "status.spotBatteryDischargeToHome.automaticDischargeMode": "Automatic discharging of the battery according to capacity",
  "status.spotBatteryDischargeToHome.highPriceDischargeMode": "Discharging the battery at high price",
  "status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode": "Discharging the battery at medium and high price",
  "status.spotBatteryDischargeToHome.notControlled": "Discharging the battery is not limited",
  "status.spotHeatPump.flexibilityPV": "Flexibility used for PV",
  "status.spotHeatPump.flexibilitySpot": "Flexibility used for SPOT",
  "status.spotHeatPump.noData": "No data for control",
  "status.spotHeatPump.spotNotLicensed": "Spot is not licensed",
  "status.spotHeatWater.flexibilityPV": "Flexibility used for PV",
  "status.spotHeatWater.flexibilitySpot": "Flexibility used for SPOT",
  "status.spotHeatWater.noData": "No data for control",
  "status.spotHeatWater.spotNotLicensed": "Spot is not licensed",
  "status.spotSmartMeter.noData": "No data for control",
  "status.spotSmartMeter.overflowDisabled": "Permanent overflow limitation",
  "status.spotSmartMeter.overflowFlexibilitySell": "Optimization of overflow for sale",
  "status.spotSmartMeter.overflowLimited": "Overflow limited due to negative price",
  "status.spotSmartMeter.spotNotLicensed": "Spot is not licensed",
  "status.spotSmartMeter.withoutReduction": "Without limitation",
  "status.wind.production": "Producing energy",
  "status.wind.stop": "STOP",
  "status.wind.unavailable": "Unavailable",
  "subscriptions.fetch": "Update subscription",
  "subscriptions.fetch.button": "Update subscription",
  "subscriptions.last_fetch_at": "Last update",
  "subscriptions.premium_active": "Premium active",
  "subscriptions.title": "Subscription",
  "test-product.app": "Application",
  "test-product.settings": "Settings",
  "test-product.settings.distribution": "Distribution",
  "test-product.settings.distribution.Dzd": "DZD",
  "test-product.settings.distribution.Infigy": "Infigy",
  "test-product.settings.distribution.solid_sun": "SolidSun",
  "test-product.settings.license": "License",
  "test-product.settings.license.HW": "HW",
  "test-product.settings.license.Industrial": "Industrial",
  "test-product.settings.license.Play": "PLAY",
  "test-product.settings.license.Smart": "Smart",
  "test-product.settings.license.basic": "Basic",
  "test-product.test": "Device test",
  "test-product.test.DC": "Checking the DC circuit",
  "test-product.test.DC.subtitle": "Connecting the terminals, cable dimensions",
  "test-product.test.component": "Component inspection",
  "test-product.test.component.subtitle": "Is a sensor, labels, ...?",
  "test-product.test.electricmeter": "Checking the smartmeter",
  "test-product.test.electricmeter.subtitle": "Checking the installation of the smartmeter for the inverter",
  "test-product.test.internet-connect": "Internet connection",
  "test-product.test.inverter-connect": "Connecting the inverter",
  "test-product.test.license": "License",
  "test-product.test.license-info": "License",
  "test-product.test.phase_1": "Phase 1 test",
  "test-product.test.phase_2": "Phase 2 test",
  "test-product.test.phase_3": "Phase 3 test",
  "test-product.test.serialNumber": "Serial number of the unit",
  "test-product.test.serialNumber.label": "Serial number",
  "test-product.test.serialNumber.subtitle": "Without a serial number, the name of the tester and the test cannot be entered",
  "test-product.test.serialNumberSwitchboard": "Production number of the cabinet",
  "test-product.test.serialNumberSwitchboard.label": "Serial number",
  "test-product.test.serialNumberSwitchboard.subtitle": "Fill in case the device is in the original cabinet",
  "test-product.test.start": "If the device is connected",
  "test-product.test.start.button": "Activate the test",
  "test-product.test.switchboard": "Checking the compliance of the cabinet",
  "test-product.test.switchboard.subtitle": "Checking the connection of the terminals, the placement of the components, the correct cable dimensions",
  "test-product.test.temp": "Temperature sensor",
  "test-product.test.tester": "Device tested by",
  "test-product.test.tester.subtitle": "Without a name, the test cannot be activated",
  "thermostat.general": "General settings",
  "thermostat.general.cooling": "Cooling active",
  "thermostat.general.cooling.pvstability": "Potential activation of the source",
  "thermostat.general.heating": "Heating active",
  "thermostat.range": "Thermostat",
  "thermostat.range.flexibility-temperature": "Flexible temperature",
  "thermostat.range.flexibility-temperature.subtitle": "Temperature by which the house can be preheated or precooled",
  "thermostat.range.flexibility_status": "Thermostat flexibility mode",
  "thermostat.range.on": "Thermostat active",
  "thermostat.range.on.subtitle": "Base temperature",
  "thermostat.range.pv-flexibility": "Control by photovoltaics",
  "thermostat.range.set_temperature": "Set temperature",
  "thermostat.range.sp-flexibility-down": "Postpone consumption according to spot",
  "thermostat.range.sp-flexibility-up": "Increase consumption according to spot",
  "thermostat.range.status": "Thermostat flexibility mode",
  "thermostat.range.temperature": "Set temperature",
  "thermostat.statisticsTemp": "Thermostat temperature",
  "thermostat.status": "Thermostat mode",
  "wallbox.3a.on": "Mode 3A",
  "wallbox.3a.on_sub": "Charging can draw 3A from the distribution network",
  "wallbox.6a.on": "Mode 6A",
  "wallbox.6a.on_sub": "Charging only from photovoltaics",
  "wallbox.NO_CHARGE": "Do not charge",
  "wallbox.NO_CHARGE.on_sub": "Charging is permanently blocked; only a schedule can start it",
  "wallbox.PV": "Charging according to battery",
  "wallbox.PV.batteryStart": "Turn on while fully charged",
  "wallbox.PV.batteryStart.subtitle": "Start charging when the battery is charging",
  "wallbox.PV.batteryStop": "Turn off while fully charged",
  "wallbox.PV.batteryStop.subtitle": "Stop charging when the battery is charging",
  "wallbox.PV.on": "Active",
  "wallbox.PV.on_sub": "After reaching the baseline energy, charging will occur only when the battery is fully charged",
  "wallbox.PV2": "Charging according to PV",
  "wallbox.PV2.on": "Active",
  "wallbox.PV2.on_sub": "Charging control according to PV performance",
  "wallbox.PV_FAST": "Priority charging according to battery",
  "wallbox.PV_FAST.batteryMinSoc": "Minimum battery reserve",
  "wallbox.PV_FAST.batteryMinSoc.subtitle": "The battery will not be discharged below this value for car charging. Until this value is exceeded, charging waits",
  "wallbox.PV_FAST.on_sub": "Car charging will have full priority. Only energy from the battery or PV will be used",
  "wallbox.SPOT": "Charging according to spot prices",
  "wallbox.SPOT.hi": "Prevent charging at high prices",
  "wallbox.SPOT.mi": "Prevent charging at mid prices",
  "wallbox.SPOT.on": "Active",
  "wallbox.SPOT.on_sub": "After reaching the baseline energy, blocking will occur during high spot prices",
  "wallbox.active": "{name}",
  "wallbox.active.subtitle": "Active",
  "wallbox.alfen": "Alfen",
  "wallbox.authorization.status": "Authorization",
  "wallbox.authorization.status.authorized": "Authorized{cardInfo}",
  "wallbox.authorization.status.denied": "Denied{cardInfo}",
  "wallbox.authorization.status.pending": "Not authorized",
  "wallbox.authorization.status.unknown": "Unknown status",
  "wallbox.az_router": "AZ Router",
  "wallbox.common": "General information",
  "wallbox.common.power": "Current consumption",
  "wallbox.common.power_today": "Today's consumption:",
  "wallbox.common.power_total": "Total consumption",
  "wallbox.common.power_year": "Annual consumption:",
  "wallbox.control": "Charging mode",
  "wallbox.ecovolter": "EcoVolter",
  "wallbox.evmate": "EVmate",
  "wallbox.fast-charge": "Fast charging",
  "wallbox.fast-charge.energy": "Energy for fast charging",
  "wallbox.fast-charge.energy_actual": "Charged energy in the current cycle",
  "wallbox.fast-charge.energy_sub": "Energy that is always charged as quickly as possible. After reaching this value, charging is controlled by one of the modes.",
  "wallbox.goodwe-ev-charger": "Goodwe",
  "wallbox.inactive.subtitle": "Inactive",
  "wallbox.mode.pv.batteryStopConflict.description": "If the battery blocking is enabled when the wallbox is operating, the mode „Charge according to battery“ cannot be enabled. To enable the mode „Charge according to battery“, you must first turn off the battery blocking on the „Photovoltaics“ page.",
  "wallbox.mode.pv.batteryStopConflict.title": "Mode cannot be enabled",
  "wallbox.mybox": "MyBox",
  "wallbox.none": "None",
  "wallbox.nonemode": "Regular charging",
  "wallbox.nonemode.amper-auto": "Automatic control of the charging current",
  "wallbox.nonemode.amper-auto.subtitle": "Controls charging to minimize charging and discharging of the battery",
  "wallbox.nonemode.ampers": "Maximum charging current",
  "wallbox.nonemode.hdo": "Charging only at low tariff",
  "wallbox.nonemode.hdo_sub": "The HDO times must be set in the general settings",
  "wallbox.nonemode.on": "Active",
  "wallbox.nonemode.on_sub": "The car charges as quickly as possible",
  "wallbox.olife": "Olife",
  "wallbox.other": "Other",
  "wallbox.pv.ampers-auto": "Current desired charging current",
  "wallbox.schedules.description": "Schedule EV charging as needed.",
  "wallbox.schedules.title": "Charging scheduler",
  "wallbox.settings": "Settings",
  "wallbox.solax": "Solax - communication via inverter",
  "wallbox.solax-ev-charger": "Solax - communication via Infigy",
  "wallbox.statistics": "Statistics",
  "wallbox.status": "Wallbox mode",
  "wallbox.status.car_not_connected": "Car not connected",
  "wallbox.status.charging": "Charging",
  "wallbox.status.charging_with_ventilation": "Charging with ventilation",
  "wallbox.status.error": "Error",
  "wallbox.status.home": "Wallbox mode",
  "wallbox.status.normal": "Normal",
  "wallbox.status.not_connected": "Cannot establish connection",
  "wallbox.status.off": "Wallbox off",
  "wallbox.status.ready": "Ready to charge",
  "wallbox.sub_status.auto": "according to auto. mode",
  "wallbox.sub_status.basic_energy": "basic energy",
  "wallbox.sub_status.battery": "according to battery",
  "wallbox.sub_status.battery_fast": "priority according to battery",
  "wallbox.sub_status.battery_waiting": ", waiting for battery charge",
  "wallbox.sub_status.hdo_block": ", HDO block",
  "wallbox.sub_status.no_charging": ", charging is disabled",
  "wallbox.sub_status.none": "",
  "wallbox.sub_status.photovoltaics": "according to PV",
  "wallbox.sub_status.schedule": "according to scheduler",
  "wallbox.sub_status.spot": "according to SPOT",
  "wallbox.sub_status.spot_high": ", high SPOT price",
  "wallbox.sub_status.spot_mid": ", medium SPOT price",
  "wallbox.victron-ev-charger": "Victron EV Charger",
  "wallbox.wallboxes.title": "Wallboxes",
  "wallbox_rfid.add_button": "Add RFID card",
  "wallbox_rfid.delete.cancel": "Cancel",
  "wallbox_rfid.delete.confirm": "Delete",
  "wallbox_rfid.delete.confirm.title": "Delete card {name}?",
  "wallbox_rfid.dialog.already_exists": "Card {id} is already stored under the name {name}.",
  "wallbox_rfid.dialog.already_exists_hint": "Please place another card or close the dialog.",
  "wallbox_rfid.dialog.cancel": "Cancel",
  "wallbox_rfid.dialog.name_label": "Name of the card",
  "wallbox_rfid.dialog.save": "Save",
  "wallbox_rfid.dialog.scanned_id": "Card ID: {id}",
  "wallbox_rfid.dialog.title": "Add RFID card",
  "wallbox_rfid.dialog.waiting": "Please place the card to the reader…",
  "wallbox_rfid.edit.dialog.title": "Edit RFID card",
  "wallbox_wizard.cancel": "Cancel",
  "wallbox_wizard.custom_device_ip_address.alert": "Please make sure that the wallbox IP address does not change (e.g. when the wallbox uses a DHCP address).",
  "wallbox_wizard.custom_device_ip_address.input": "Wallbox IP address",
  "wallbox_wizard.multiple_wallboxes.alert": "For the configuration of multiple wallboxes, please contact the support line. Contact can be found in the technical wiki Infigy.",
  "wallbox_wizard.multiple_wallboxes.label": "Multiple wallboxes",
  "wallbox_wizard.open": "Configure wallbox",
  "wallbox_wizard.save": "Save",
  "wallbox_wizard.title": "Wallbox configuration",
  "welcome.subtitle": "Applications for domestic and modern energy in one place!",
  "welcome.title": "Welcome to Infigy!",
  "wifi_ap_config.interface_block.confirm.confirmation_text": "{blocked, select, true {Block} other {Unblock}}",
  "wifi_ap_config.interface_block.confirm.content": "Do you really want to {blocked, select, true {block} other {unblock}} WiFi?",
  "wifi_ap_config.interface_block.confirm.title": "Change WiFi Status",
  "wifi_ap_config.passphrase_change.confirm.passphrase": "Password",
  "wifi_ap_config.passphrase_change.confirm.title": "Change WiFi Password",
  "wifi_ap_config.wifi_interface_blocked.button": "{blocked, select, true {Unblock} other {Block}}",
  "wifi_ap_config.wifi_interface_blocked.title": "WiFi Status",
  "wifi_ap_config.wifi_interface_blocked.value": "{blocked, select, true {Blocked} other {Active}}",
  "wind.common": "General information",
  "wind.common.battery_charged_total": "Total power to battery",
  "wind.common.battery_current": "Battery current",
  "wind.common.battery_power": "Battery power",
  "wind.common.battery_voltage": "Battery voltage",
  "wind.common.load_current": "Load current",
  "wind.common.power": "Current wind power",
  "wind.common.power_today": "Today's production:",
  "wind.common.power_total": "Total production",
  "wind.common.power_year": "Annual production:",
  "wind.common.resistor_power": "Load current",
  "wind.statistics": "Statistics",
  "wind.statistics.battery_charge_power": "Battery power",
  "wind.statistics.load_current": "Load current",
  "wind.statistics.power": "Wind turbine power",
  "wind.statistics.wind_speed": "Wind speed",
  "wind.status": "Wind turbine mode"
}
